import React from "react";

export default function IconUserResearchNotCss() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="animated"
      version="1.1"
      viewBox="0 0 500 500"
    >
      <g
        className="animable"
        style={{
          WebkitTransformOrigin: 251.579,
          MsTransformOrigin: 251.579,
          transformOrigin: 251.579,
        }}
      >
        <path
          d="M327.83 53.06s-79.34-31.17-155.22 12.82S60.28 200.38 28.83 272.82 18.63 420.43 78.41 456.1s98.47-13.38 181-13.52 105.06 12.73 172.29-33.76 76.55-160.45 20.22-246.54S327.83 53.06 327.83 53.06z"
          style={{
            WebkitTransformOrigin: 251.579,
            MsTransformOrigin: 251.579,
            transformOrigin: 251.579,
          }}
          fill="#4CB967"
          className="animable"
        ></path>
        <path
          d="M327.83 53.06s-79.34-31.17-155.22 12.82S60.28 200.38 28.83 272.82 18.63 420.43 78.41 456.1s98.47-13.38 181-13.52 105.06 12.73 172.29-33.76 76.55-160.45 20.22-246.54S327.83 53.06 327.83 53.06z"
          style={{
            WebkitTransformOrigin: 251.579,
            MsTransformOrigin: 251.579,
            transformOrigin: 251.579,
          }}
          fill="#FFF"
          className="animable"
          opacity="0.7"
        ></path>
      </g>
      <g
        className="animable"
        style={{
          WebkitTransformOrigin: 244.66,
          MsTransformOrigin: 244.66,
          transformOrigin: 244.66,
        }}
      >
        <path
          style={{
            WebkitTransformOrigin: 244.66,
            MsTransformOrigin: 244.66,
            transformOrigin: 244.66,
          }}
          fill="#263238"
          d="M6.14 461.45H483.18V462.45H6.14z"
          className="animable"
        ></path>
      </g>
      <g
        className="animable"
        style={{
          WebkitTransformOrigin: 248.171,
          MsTransformOrigin: 248.171,
          transformOrigin: 248.171,
        }}
      >
        <path
          d="M426.64 413.78c1.94.49 6.47-.31 6.47-.31s-1.27-2.71-1.37-2.87c-1.21-1.84-4.7-4.66-7.22-3.93a3.13 3.13 0 00-2.08 4.07c.56 1.64 2.56 2.62 4.2 3.04z"
          style={{
            WebkitTransformOrigin: 427.682,
            MsTransformOrigin: 427.682,
            transformOrigin: 427.682,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M454.85 461l.08.29 1.77.38c-.12-.38-.24-.77-.37-1.17-.36-1.14-.77-2.34-1.2-3.57.29-.17 1.93-1.1 3.37-2.15 1.47 1.17 5 2.25 5.48 2.39-.35 1.16-.7 2.29-1.05 3.35-.24.73-.47 1.43-.7 2.11l1.71-.27c.16-.48.31-1 .46-1.48.36-1.18.73-2.45 1.08-3.75.5 0 4.56.18 6.37-.51 1.65-.63 3.59-1.86 4.18-3.57a2.8 2.8 0 00-2.11-3.81c-2.53-.41-6 2.85-7.18 4.85-.07.12-.69 1.47-1.07 2.33.15-.53.29-1 .43-1.6.29-1.09.54-2.18.82-3.35.11-.57.23-1.14.34-1.72s.19-1.19.28-1.79c.2-1.4.33-2.82.42-4.25 1 .18 4.42.78 6.14.39s3.81-1.33 4.65-2.95a2.82 2.82 0 00-1.47-4.11c-2.41-.78-6.32 2-7.79 3.78-.1.12-1 1.53-1.5 2.31.05-.86.11-1.72.13-2.59.07-2.51.05-5 .05-7.59v-2.33c.34.07 4.42.87 6.35.44 1.71-.39 3.8-1.33 4.65-3a2.82 2.82 0 00-1.47-4.11c-2.41-.78-6.32 2-7.8 3.78-.11.14-1.42 2.17-1.73 2.7 0-1.71 0-3.41.14-5.09a49.8 49.8 0 01.82-6.79c.16 0 4.41.88 6.38.44 1.71-.39 3.8-1.33 4.65-2.95a2.82 2.82 0 00-1.46-4.04c-2.41-.78-6.32 2-7.79 3.78-.12.14-1.53 2.33-1.76 2.74 0-.13 0-.26.06-.39a38.91 38.91 0 012.07-6.63c.48-1.2 1-2.32 1.53-3.41.77.24 4.31 1.29 6.11 1.08s3.91-.92 4.93-2.46a2.83 2.83 0 00-1-4.26c-2.3-1-6.47 1.29-8.13 2.95-.09.09-.91 1.1-1.5 1.85.25-.49.5-1 .74-1.45.92-1.74 1.87-3.28 2.73-4.63.49-.77 1-1.46 1.38-2.1.91-.15 4.56-.83 6.08-1.8s3.14-2.54 3.34-4.31a2.81 2.81 0 00-2.93-3.23c-2.6.14-5.3 4-6 6.17-.06.19-.7 3.22-.66 3.21h.06c-.43.61-.89 1.26-1.37 2-.89 1.35-1.88 2.87-2.84 4.6a58.92 58.92 0 00-2.84 5.68 39.67 39.67 0 00-2.24 6.68v.08c-.06-.73-.3-2.76-.34-2.91-.52-2.15-2.86-5.94-5.45-6a3.26 3.26 0 00-3.25 3.32c0 1.77 1.53 3.31 2.94 4.22 1.57 1 5.73 1.6 6.06 1.64a51.82 51.82 0 00-1 7c-.11 1.37-.18 2.75-.23 4.13-.07-.63-.14-1.19-.16-1.27-.53-2.15-2.87-5.94-5.46-6a3.25 3.25 0 00-3.24 3.32c0 1.77 1.53 3.31 2.93 4.22s4.94 1.48 5.88 1.62v1.59c-.06 2.54-.1 5.08-.22 7.57 0 .87-.12 1.74-.19 2.61l-.14-1.1c-.53-2.16-2.87-5.94-5.46-6a3.25 3.25 0 00-3.24 3.32c0 1.77 1.53 3.31 2.93 4.22s4.6 1.42 5.71 1.59c-.1.89-.2 1.77-.34 2.63-.11.58-.17 1.15-.31 1.73s-.26 1.15-.38 1.72c-.28 1.09-.57 2.21-.87 3.27-.21.73-.42 1.43-.63 2.13.06-.87.12-2.58.11-2.73a10.71 10.71 0 00-2.16-5.3 4.64 4.64 0 00-.16-.69 2.92 2.92 0 00-4-1.91c-2.44 1-3.59 5.49-3.48 7.72 0 .13.24 1.55.41 2.43-.18-.5-.35-1-.54-1.5-.37-1-.78-2-1.2-3.12l-.69-1.56c-.22-.53-.52-1.05-.78-1.59a50.66 50.66 0 00-2.06-3.62c.95-.37 4.28-1.74 5.55-3s2.55-3.1 2.36-4.85a2.86 2.86 0 00-3.62-2.5c-2.54.67-4.37 5-4.61 7.2v2.65c-.45-.72-.89-1.44-1.37-2.15-1.37-2-2.84-4.07-4.29-6.09l-1.31-1.87c.33-.13 4.33-1.68 5.75-3.05 1.27-1.22 2.55-3.1 2.36-4.85a2.87 2.87 0 00-3.62-2.5c-2.54.67-4.37 4.95-4.61 7.2v3.09c-1-1.38-1.91-2.75-2.78-4.15a48.64 48.64 0 01-3.17-5.87c.16-.06 4.34-1.66 5.8-3.07 1.26-1.22 2.54-3.1 2.35-4.85a2.87 2.87 0 00-3.62-2.5c-2.54.67-4.37 5-4.61 7.2v3.14c0-.12-.12-.24-.17-.36a35.2 35.2 0 01-2-6.41 39.81 39.81 0 01-.61-3.54c.8-.22 4.47-1.27 5.92-2.41s2.86-2.83 2.87-4.6a2.83 2.83 0 00-3.28-2.89c-2.59.4-4.88 4.49-5.37 6.71 0 .13-.17 1.37-.25 2.28-.06-.52-.14-1.05-.19-1.55-.19-1.88-.24-3.62-.27-5.16v-2.42c.69-.61 3.48-3.11 4.25-4.7s1.27-3.71.44-5.24a3 3 0 00-4.39-1c-2.18 1.5-2.33 6-1.72 8.17.05.18 1.22 2.95 1.25 2.92h.05c0 .72-.06 1.49-.06 2.33 0 1.54 0 3.29.16 5.19a48.56 48.56 0 00.78 6.07 36.24 36.24 0 001.86 6.54v.07c-.47-.55-1.84-2-2-2.15-1.69-1.44-5.88-3.22-8.16-1.87a3 3 0 00-.93 4.38c1 1.4 3.22 1.84 5 1.81 1.95 0 5.88-1.79 6.2-1.93a47.47 47.47 0 003.13 6.15c.68 1.16 1.41 2.3 2.15 3.43-.42-.46-.8-.88-.86-.93-1.69-1.44-5.88-3.22-8.16-1.88a3 3 0 00-.92 4.39c1 1.4 3.22 1.84 4.95 1.81s5.14-1.46 6-1.85c.29.43.57.86.87 1.29 1.4 2.07 2.81 4.12 4.13 6.17.46.73.89 1.46 1.32 2.19-.37-.41-.69-.75-.75-.8-1.68-1.44-5.87-3.22-8.15-1.88a3 3 0 00-.93 4.39c1 1.4 3.22 1.84 5 1.81s4.81-1.32 5.87-1.78c.42.76.84 1.52 1.21 2.28.24.53.51 1 .71 1.55l.65 1.58c.38 1 .77 2.07 1.11 3.08.24.7.46 1.37.68 2-.46-.73-1.38-2.13-1.47-2.24-1.42-1.68-5.24-4.07-7.69-3.07a3.07 3.07 0 00-1.59 4.24c.79 1.55 2.86 2.31 4.56 2.54 1.87.25 5.84-.87 6.34-1 .45 1.12.79 2.26 1.09 3.26z"
          style={{
            WebkitTransformOrigin: 455.67,
            MsTransformOrigin: 455.67,
            transformOrigin: 455.67,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M472.66 407.61s.53-3 .53-3.23c.1-2.24-1.09-6.56-3.53-7.28a3.28 3.28 0 00-4 2.42c-.46 1.75.54 3.65 1.62 4.89 1.29 1.47 5.37 3.19 5.38 3.2z"
          style={{
            WebkitTransformOrigin: 469.371,
            MsTransformOrigin: 469.371,
            transformOrigin: 469.371,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M11.33 434.72a13 13 0 003.69-.18s-.72-1.54-.78-1.63c-.69-1.06-2.68-2.67-4.12-2.25A1.79 1.79 0 008.93 433a3.36 3.36 0 002.4 1.72z"
          style={{
            WebkitTransformOrigin: 11.9199,
            MsTransformOrigin: 11.9199,
            transformOrigin: 11.9199,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M27.44 461.68v.16l1 .22-.21-.67c-.21-.65-.44-1.34-.69-2a21.46 21.46 0 001.93-1.23 12 12 0 003.13 1.37c-.2.66-.4 1.31-.6 1.91-.14.42-.27.82-.41 1.21l1-.16c.08-.27.17-.55.26-.84.2-.68.41-1.4.61-2.14a12.81 12.81 0 003.64-.29 4 4 0 002.39-2.05 1.6 1.6 0 00-1.16-2.17c-1.44-.23-3.42 1.63-4.1 2.77 0 .07-.39.84-.61 1.33.08-.3.17-.6.25-.91.16-.62.31-1.24.46-1.91.07-.33.13-.66.2-1s.11-.68.16-1q.16-1.2.24-2.43a11.53 11.53 0 003.51.22 3.93 3.93 0 002.65-1.68 1.6 1.6 0 00-.84-2.34c-1.38-.45-3.61 1.11-4.45 2.15 0 .07-.57.87-.85 1.32 0-.49.06-1 .07-1.48v-5.66a12.58 12.58 0 003.63.25 4 4 0 002.65-1.69 1.59 1.59 0 00-.83-2.34c-1.38-.45-3.61 1.12-4.46 2.15-.06.08-.81 1.24-1 1.55 0-1 0-1.95.08-2.91a30.69 30.69 0 01.47-3.88 12.6 12.6 0 003.65.25A4 4 0 0041.9 436a1.61 1.61 0 00-.84-2.35c-1.38-.44-3.61 1.12-4.45 2.16-.07.08-.87 1.33-1 1.57v-.23a23 23 0 011.19-3.79c.27-.68.56-1.32.87-1.94a11.58 11.58 0 003.49.62 4 4 0 002.84-1.38 1.61 1.61 0 00-.56-2.43c-1.31-.6-3.69.73-4.64 1.68 0 0-.52.63-.86 1.06.15-.28.29-.57.43-.83.52-1 1.07-1.87 1.55-2.65.28-.44.55-.83.8-1.19a12.84 12.84 0 003.47-1 3.89 3.89 0 001.91-2.47 1.61 1.61 0 00-1.68-1.83c-1.48.08-3 2.28-3.45 3.53 0 .1-.4 1.83-.37 1.83-.25.35-.51.72-.79 1.14-.5.76-1.07 1.63-1.61 2.62a29.81 29.81 0 00-1.63 3.25 22.71 22.71 0 00-1.28 3.81.09.09 0 010 .05c0-.42-.17-1.58-.19-1.67-.3-1.23-1.64-3.39-3.12-3.42a1.85 1.85 0 00-1.83 1.86 3.27 3.27 0 001.67 2.41 11.92 11.92 0 003.47.94 29.11 29.11 0 00-.58 4c-.06.78-.1 1.57-.13 2.36 0-.36-.08-.68-.09-.73-.3-1.23-1.64-3.39-3.12-3.42a1.85 1.85 0 00-1.85 1.89 3.27 3.27 0 001.67 2.41 11.27 11.27 0 003.36.93v.9c0 1.46-.06 2.9-.13 4.33 0 .5-.06 1-.11 1.49 0-.32-.07-.59-.08-.63-.3-1.23-1.63-3.39-3.11-3.42a1.86 1.86 0 00-1.86 1.89 3.3 3.3 0 001.68 2.41 11 11 0 003.26.91c-.06.51-.11 1-.19 1.5-.06.33-.1.66-.18 1s-.15.66-.22 1c-.16.62-.32 1.26-.5 1.87-.11.42-.23.81-.35 1.22 0-.5.06-1.48.06-1.56a6.07 6.07 0 00-1.24-3 2.2 2.2 0 00-.06-.37 1.66 1.66 0 00-2.28-1.09c-1.39.58-2 3.13-2 4.41 0 .07.14.88.23 1.39-.1-.29-.2-.57-.31-.86-.21-.59-.44-1.16-.68-1.78l-.39-.9c-.13-.3-.3-.6-.45-.9-.36-.7-.76-1.39-1.17-2.07a12.76 12.76 0 003.17-1.7A3.74 3.74 0 0029 448a1.63 1.63 0 00-2.06-1.42c-1.46.38-2.5 2.82-2.64 4.11v1.51c-.25-.41-.51-.82-.78-1.22-.79-1.17-1.62-2.33-2.45-3.49l-.75-1.06a13.6 13.6 0 003.29-1.75 3.74 3.74 0 001.34-2.77 1.63 1.63 0 00-2.06-1.42c-1.46.38-2.5 2.82-2.64 4.11v1.76c-.55-.78-1.09-1.57-1.59-2.37a28 28 0 01-1.81-3.35 13.45 13.45 0 003.31-1.75 3.77 3.77 0 001.35-2.77 1.64 1.64 0 00-2.07-1.43c-1.45.38-2.49 2.83-2.63 4.11v1.79l-.1-.2a20.45 20.45 0 01-1.13-3.66 19 19 0 01-.35-2 13.05 13.05 0 003.38-1.38 3.83 3.83 0 001.64-2.63 1.61 1.61 0 00-1.88-1.64c-1.47.22-2.78 2.56-3.07 3.83 0 .07-.09.78-.14 1.3 0-.3-.07-.6-.1-.89-.11-1.07-.14-2.07-.16-3v-1.38a12.8 12.8 0 002.42-2.68 3.48 3.48 0 00.25-3 1.72 1.72 0 00-2.5-.58c-1.25.86-1.33 3.45-1 4.67 0 .1.69 1.68.71 1.66v1.33c0 .88 0 1.88.1 3a28.89 28.89 0 00.44 3.47 20.33 20.33 0 001.07 3.74c-.26-.32-1.05-1.17-1.11-1.23-1-.82-3.36-1.84-4.66-1.07a1.71 1.71 0 00-.53 2.5 3.51 3.51 0 002.83 1 13.38 13.38 0 003.54-1.1 28.24 28.24 0 001.78 3.51c.4.66.81 1.31 1.24 2-.24-.26-.46-.49-.5-.52-1-.83-3.35-1.84-4.66-1.08a1.72 1.72 0 00-.52 2.51 3.49 3.49 0 002.82 1 12.14 12.14 0 003.5-1.07l.49.74c.81 1.18 1.61 2.35 2.36 3.53.27.41.51.83.76 1.25-.21-.24-.4-.43-.43-.46-1-.82-3.35-1.84-4.66-1.07a1.71 1.71 0 00-.53 2.5 3.55 3.55 0 002.83 1 12.24 12.24 0 003.35-1c.24.43.48.87.69 1.3s.29.58.41.89.25.6.37.9c.22.58.44 1.18.64 1.76.13.4.26.78.38 1.17a37.8 37.8 0 00-.83-1.28c-.82-1-3-2.33-4.4-1.76a1.76 1.76 0 00-.91 2.42 3.43 3.43 0 002.61 1.45 12.92 12.92 0 003.62-.57c.2.7.4 1.32.57 1.91z"
          style={{
            WebkitTransformOrigin: 27.9361,
            MsTransformOrigin: 27.9361,
            transformOrigin: 27.9361,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M37.61 431.19s.3-1.73.31-1.84c0-1.28-.63-3.74-2-4.15a1.86 1.86 0 00-2.27 1.38 3.32 3.32 0 00.92 2.79 11.59 11.59 0 003.04 1.82z"
          style={{
            WebkitTransformOrigin: 35.7688,
            MsTransformOrigin: 35.7688,
            transformOrigin: 35.7688,
          }}
          fill="#263238"
          className="animable"
        ></path>
      </g>
      <g
        className="animable"
        style={{
          WebkitTransformOrigin: 424.775,
          MsTransformOrigin: 424.775,
          transformOrigin: 424.775,
        }}
      >
        <path
          d="M460 96.56h-70.41v-5.68H460zm-69.44-1H459v-3.68h-68.41z"
          style={{
            WebkitTransformOrigin: 424.795,
            MsTransformOrigin: 424.795,
            transformOrigin: 424.795,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M425 105.91h-35.41v-5.68H425zm-34.37-1H424v-3.68h-33.41z"
          style={{
            WebkitTransformOrigin: 407.295,
            MsTransformOrigin: 407.295,
            transformOrigin: 407.295,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M437.55 115.25h-48v-5.67h48zm-47-1h46v-3.67h-46z"
          style={{
            WebkitTransformOrigin: 413.55,
            MsTransformOrigin: 413.55,
            transformOrigin: 413.55,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M419.56 124.6h-30v-5.67h30zm-29-1h28v-3.67h-28z"
          style={{
            WebkitTransformOrigin: 404.56,
            MsTransformOrigin: 404.56,
            transformOrigin: 404.56,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M443.78 134h-54.19v-5.67h54.19zm-53.19-1h52.19v-3.67h-52.19z"
          style={{
            WebkitTransformOrigin: 416.685,
            MsTransformOrigin: 416.685,
            transformOrigin: 416.685,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M427.51 143.3h-37.92v-5.68h37.92zm-36.92-1h35.92v-3.68h-35.92z"
          style={{
            WebkitTransformOrigin: 408.55,
            MsTransformOrigin: 408.55,
            transformOrigin: 408.55,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M432 152.65h-42.41V147H432zm-41.42-1H431V148h-40.41z"
          style={{
            WebkitTransformOrigin: 410.795,
            MsTransformOrigin: 410.795,
            transformOrigin: 410.795,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 408.17,
            MsTransformOrigin: 408.17,
            transformOrigin: 408.17,
          }}
          fill="#263238"
          d="M390.7 82H425.64V83H390.7z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 408.17,
            MsTransformOrigin: 408.17,
            transformOrigin: 408.17,
          }}
          fill="#263238"
          d="M390.7 76.12H425.64V77.12H390.7z"
          className="animable"
        ></path>
      </g>
      <g
        className="animable"
        style={{
          WebkitTransformOrigin: 42.85,
          MsTransformOrigin: 42.85,
          transformOrigin: 42.85,
        }}
      >
        <path
          d="M42.86 142.18a16.73 16.73 0 1116.72-16.72 16.75 16.75 0 01-16.72 16.72zm0-32.45a15.73 15.73 0 1015.72 15.73 15.75 15.75 0 00-15.72-15.73z"
          style={{
            WebkitTransformOrigin: 42.85,
            MsTransformOrigin: 42.85,
            transformOrigin: 42.85,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M42.86 129.86a6.25 6.25 0 116.25-6.25 6.26 6.26 0 01-6.25 6.25zm0-11.5a5.25 5.25 0 105.25 5.25 5.25 5.25 0 00-5.25-5.25z"
          style={{
            WebkitTransformOrigin: 42.86,
            MsTransformOrigin: 42.86,
            transformOrigin: 42.86,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M42.86 142.18a16.53 16.53 0 01-10.06-3.39l-.24-.18v-.3a10.39 10.39 0 0120.5 0v.3l-.24.18a16.56 16.56 0 01-9.96 3.39zm-9.21-4a15.64 15.64 0 0018.42 0 9.39 9.39 0 00-18.42 0z"
          style={{
            WebkitTransformOrigin: 42.81,
            MsTransformOrigin: 42.81,
            transformOrigin: 42.81,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M42.86 182.91a16.73 16.73 0 1116.72-16.72 16.75 16.75 0 01-16.72 16.72zm0-32.45a15.73 15.73 0 1015.72 15.73 15.75 15.75 0 00-15.72-15.73z"
          style={{
            WebkitTransformOrigin: 42.85,
            MsTransformOrigin: 42.85,
            transformOrigin: 42.85,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M42.86 170.59a6.25 6.25 0 116.25-6.25 6.26 6.26 0 01-6.25 6.25zm0-11.5a5.25 5.25 0 105.25 5.25 5.25 5.25 0 00-5.25-5.25z"
          style={{
            WebkitTransformOrigin: 42.86,
            MsTransformOrigin: 42.86,
            transformOrigin: 42.86,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M42.86 182.91a16.59 16.59 0 01-10.06-3.38l-.24-.19v-.3a10.39 10.39 0 0120.5 0v.3l-.24.19a16.63 16.63 0 01-9.96 3.38zm-9.21-4a15.64 15.64 0 0018.42 0 9.39 9.39 0 00-18.42 0z"
          style={{
            WebkitTransformOrigin: 42.81,
            MsTransformOrigin: 42.81,
            transformOrigin: 42.81,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M42.86 223.64a16.73 16.73 0 1116.72-16.72 16.75 16.75 0 01-16.72 16.72zm0-32.45a15.73 15.73 0 1015.72 15.73 15.75 15.75 0 00-15.72-15.73z"
          style={{
            WebkitTransformOrigin: 42.85,
            MsTransformOrigin: 42.85,
            transformOrigin: 42.85,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M42.86 211.32a6.25 6.25 0 116.25-6.25 6.25 6.25 0 01-6.25 6.25zm0-11.5a5.25 5.25 0 105.25 5.25 5.26 5.26 0 00-5.25-5.25z"
          style={{
            WebkitTransformOrigin: 42.86,
            MsTransformOrigin: 42.86,
            transformOrigin: 42.86,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M42.86 223.64a16.59 16.59 0 01-10.06-3.38l-.24-.18v-.3a10.39 10.39 0 0120.5 0v.3l-.24.18a16.61 16.61 0 01-9.96 3.38zm-9.21-4a15.64 15.64 0 0018.42 0 9.39 9.39 0 00-18.42 0z"
          style={{
            WebkitTransformOrigin: 42.81,
            MsTransformOrigin: 42.81,
            transformOrigin: 42.81,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M42.86 264.37a16.72 16.72 0 1116.72-16.72 16.75 16.75 0 01-16.72 16.72zm0-32.44a15.72 15.72 0 1015.72 15.72 15.74 15.74 0 00-15.72-15.72z"
          style={{
            WebkitTransformOrigin: 42.86,
            MsTransformOrigin: 42.86,
            transformOrigin: 42.86,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M42.86 252.05a6.25 6.25 0 116.25-6.25 6.25 6.25 0 01-6.25 6.25zm0-11.5a5.25 5.25 0 105.25 5.25 5.26 5.26 0 00-5.25-5.25z"
          style={{
            WebkitTransformOrigin: 42.86,
            MsTransformOrigin: 42.86,
            transformOrigin: 42.86,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M42.86 264.37A16.59 16.59 0 0132.8 261l-.24-.18v-.3a10.39 10.39 0 0120.5 0v.3l-.24.18a16.61 16.61 0 01-9.96 3.37zm-9.21-4a15.64 15.64 0 0018.42 0 9.39 9.39 0 00-18.42 0z"
          style={{
            WebkitTransformOrigin: 42.81,
            MsTransformOrigin: 42.81,
            transformOrigin: 42.81,
          }}
          fill="#263238"
          className="animable"
        ></path>
      </g>
      <g
        className="animable"
        style={{
          WebkitTransformOrigin: 397.627,
          MsTransformOrigin: 397.627,
          transformOrigin: 397.627,
        }}
      >
        <path
          d="M399.68 203.4s-10 1.86-12 7.16 1 6.73 1 6.73-8.16 4.44-6.58 9.6 7.3 7.73 7.3 7.73 2.29 1.58 1.86 2.58-1.86.72-1.86.72a17 17 0 007.16 3.72c4.3 1 11.17 2.29 17.19 1a36.92 36.92 0 0010.6-4.15s-4 .29-2.3-2.44 8.74-3.86 7.88-11.88-3.29-7-5.15-10.46.57-5.87-5.16-9.88-15.75-7-18.91-5.87-1.03 5.44-1.03 5.44z"
          style={{
            WebkitTransformOrigin: 405.95,
            MsTransformOrigin: 405.95,
            transformOrigin: 405.95,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M408.19 243.68a52.29 52.29 0 01-11.77-1.55 17.53 17.53 0 01-7.4-3.85l-1.25-1.19 1.7.34s1 .19 1.3-.43c.15-.35-.78-1.34-1.68-2-.17-.06-5.88-2.68-7.5-8-1.42-4.62 4.17-8.56 6.16-9.79-.88-.83-2.1-2.81-.57-6.86 1.81-4.78 9.54-6.84 11.8-7.34a5.71 5.71 0 01-.27-3.87 2.89 2.89 0 011.8-1.68c3.42-1.24 13.55 1.86 19.37 5.93 3.94 2.76 4.2 4.88 4.46 6.94a8.09 8.09 0 00.84 3.11 8.87 8.87 0 001.82 2.27c1.37 1.35 2.8 2.75 3.4 8.37.63 5.93-2.91 8.36-5.5 10.12a8.89 8.89 0 00-2.45 2.09c-.19.3-.48.84-.29 1.15s1.4.57 2.12.52l2-.14-1.7 1.06a36.77 36.77 0 01-10.76 4.22 26.75 26.75 0 01-5.63.58zm-17.52-5.35a16.59 16.59 0 006 2.82c7 1.63 12.53 2 17 1a37.15 37.15 0 009-3.3 2.13 2.13 0 01-1.35-.87 2 2 0 01.3-2.19 9.25 9.25 0 012.74-2.38c2.64-1.81 5.64-3.85 5.06-9.19s-1.8-6.48-3.1-7.77a9.57 9.57 0 01-2-2.5 8.8 8.8 0 01-1-3.47c-.24-1.92-.47-3.74-4.05-6.24-5.84-4.09-15.65-6.83-18.45-5.81a1.93 1.93 0 00-1.21 1.1c-.58 1.46.48 3.63.49 3.65l.29.59-.65.12c-.09 0-9.77 1.88-11.65 6.85-1.82 4.81.72 6.09.75 6.1l.88.42-.86.47c-.08 0-7.78 4.31-6.35 9 1.49 4.87 7 7.4 7 7.43.52.34 2.68 1.91 2.12 3.23a1.66 1.66 0 01-.96.94z"
          style={{
            WebkitTransformOrigin: 405.918,
            MsTransformOrigin: 405.918,
            transformOrigin: 405.918,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M381.21 294.49a65 65 0 00-11.8 32.16c-1.46 19 12 59.49 12.32 61.11s1.78 15.89 7 27.72 8.59 29.83 8.59 29.83-.81 3.72-.81 4.21-6.65 6.81-8.92 8.11-7.13 1.78-7 4.05 11 2.59 14.59 2.43 11.67-1.3 12.81-1.3 6.32.33 6.16-2.91-4.57-17-4.57-17-3.05-21.08-3.05-27.72-.33-22.37-.33-22.37 12 25.61 14.59 32.58 5.19 17 5.51 18.15 1.14 13.62 4.7 17.83 5.85 3.84 8 3.91c2.39.08 5.59-2.12 3.65-8s-6.81-9.89-7.78-15.72-1.46-20.43-1.46-35.34-5.84-29.82-5.84-29.82 4.38-25.29 2.27-44.74a102.58 102.58 0 00-9.85-33.9l-.52-2.09-37-3.56z"
          style={{
            WebkitTransformOrigin: 406.273,
            MsTransformOrigin: 406.273,
            transformOrigin: 406.273,
          }}
          fill="#4CB967"
          className="animable"
        ></path>
        <path
          d="M439.17 465.76h-.74c-2.07 0-4.42-.07-7.81-4.07-3-3.5-4-12.11-4.55-16.25-.1-.85-.19-1.58-.25-1.77s-.13-.49-.26-1c-.74-2.76-3-11.17-5.24-17.16-2.11-5.69-10.63-24.09-13.57-30.4.09 4.66.28 15 .28 20 0 6.53 3 27.43 3.05 27.64.16.49 4.4 13.8 4.57 17.07a2.68 2.68 0 01-.74 2.07c-1.4 1.44-4.37 1.4-5.64 1.38H408c-.45 0-2.18.21-4.19.44-2.9.34-6.5.76-8.6.86-.14 0-14.87.46-15.11-2.9-.13-1.91 2.24-2.7 4.53-3.46a15.84 15.84 0 002.7-1.06c2.13-1.22 8.1-6.89 8.67-7.78.06-.7.59-3.18.79-4.11-.28-1.46-3.63-18.42-8.54-29.62-4.49-10.23-6.23-22.45-6.8-26.46-.09-.67-.16-1.14-.2-1.36s-.34-1.16-.75-2.51c-8.53-28-12.42-47.76-11.58-58.74a66.14 66.14 0 0111.88-32.4l1.47-2.61 37.64 3.63.59 2.37a104.35 104.35 0 019.88 34c2 18.57-1.91 42.71-2.25 44.75.57 1.51 5.82 15.77 5.82 29.87 0 16.37.55 29.88 1.45 35.26.52 3.12 2.19 5.72 4 8.46a32.33 32.33 0 013.8 7.18c1.2 3.6.45 5.7-.38 6.82a4.49 4.49 0 01-3.65 1.86zm-33.51-75.32l1 2.14c.12.25 12 25.71 14.6 32.61 2.25 6 4.52 14.48 5.27 17.25.12.47.21.79.25.95a15.48 15.48 0 01.29 1.91c.46 3.73 1.55 12.46 4.32 15.73 3.09 3.66 5.11 3.69 7.06 3.72h.6a3.55 3.55 0 002.91-1.4c.7-.93 1.3-2.71.24-5.9a31.28 31.28 0 00-3.69-7c-1.75-2.71-3.55-5.51-4.11-8.84-.9-5.42-1.46-19-1.46-35.42 0-14.65-5.75-29.49-5.81-29.64l-.05-.13v-.14c0-.25 4.34-25.44 2.26-44.6a102.75 102.75 0 00-9.76-33.68l-.05-.11-.43-1.75-36.29-3.5-1.21 2.14a65.06 65.06 0 00-11.69 31.89c-.84 10.85 3 30.49 11.54 58.36.5 1.65.72 2.38.77 2.62s.11.71.21 1.41c.57 4 2.29 16.09 6.73 26.2 5.15 11.75 8.59 29.75 8.62 29.93v.2c-.39 1.8-.8 3.83-.8 4.11 0 1-7.43 7.55-9.17 8.54a16.66 16.66 0 01-2.87 1.14c-1.93.64-3.93 1.3-3.85 2.44.1 1.41 8.71 2.21 14.07 2 2-.09 5.64-.51 8.52-.85 2.12-.25 3.8-.45 4.31-.45h.3c1 0 3.8.06 4.9-1.08a1.73 1.73 0 00.46-1.32c-.16-3.14-4.5-16.76-4.55-16.89-.14-.95-3.07-21.27-3.07-27.87s-.32-22.2-.33-22.36z"
          style={{
            WebkitTransformOrigin: 406.317,
            MsTransformOrigin: 406.317,
            transformOrigin: 406.317,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M403.29 379.54c-1.46-6.24-3.24-14.65-3.5-19.26-.41-7.45-.18-28.06-.18-28.27h1c0 .21-.23 20.79.18 28.2.25 4.54 2 12.89 3.47 19.09z"
          style={{
            WebkitTransformOrigin: 401.903,
            MsTransformOrigin: 401.903,
            transformOrigin: 401.903,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M404.81 385.84s-.34-1.35-.85-3.46l1-.23c.51 2.1.85 3.44.85 3.44z"
          style={{
            WebkitTransformOrigin: 404.885,
            MsTransformOrigin: 404.885,
            transformOrigin: 404.885,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M396.76 331.48c-3-1.26-6.3-5.38-8.52-8.62l.83-.57c2.13 3.13 5.27 7.1 8.07 8.27z"
          style={{
            WebkitTransformOrigin: 392.69,
            MsTransformOrigin: 392.69,
            transformOrigin: 392.69,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M386.84 320.7c-.75-1.18-1.18-2-1.18-2l.87-.49s.43.77 1.15 1.92z"
          style={{
            WebkitTransformOrigin: 386.67,
            MsTransformOrigin: 386.67,
            transformOrigin: 386.67,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 407.245,
            MsTransformOrigin: 407.245,
            transformOrigin: 407.245,
          }}
          fill="#263238"
          d="M400.12 322.83H414.37V323.83H400.12z"
          className="animable"
          transform="rotate(-52.77)"
        ></path>
        <path
          d="M412.69 453.84a23.42 23.42 0 01-4.48.17c-5.62-.22-11.73-4.49-11.73-4.49 0 .49-6.65 6.81-8.92 8.11s-7.13 1.78-7 4.05 11 2.59 14.59 2.43 11.67-1.3 12.81-1.3 6.32.33 6.16-2.91a17.43 17.43 0 00-1.43-6.06z"
          style={{
            WebkitTransformOrigin: 397.34,
            MsTransformOrigin: 397.34,
            transformOrigin: 397.34,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M393.32 464.63c-4 0-13-.29-13.23-2.92-.13-1.91 2.24-2.7 4.53-3.46a15.84 15.84 0 002.7-1.06c2.13-1.22 8.05-6.84 8.66-7.77v-.86l.78.55c.06 0 6.07 4.19 11.47 4.4a22 22 0 004.39-.17h.33l.17.28a17.78 17.78 0 011.53 6.29 2.68 2.68 0 01-.74 2.07c-1.4 1.44-4.37 1.4-5.64 1.38H408c-.45 0-2.18.21-4.19.44-2.9.34-6.5.76-8.6.86-.04-.05-.77-.03-1.89-.03zm3.28-14.43a57.83 57.83 0 01-8.79 7.86 16.66 16.66 0 01-2.87 1.14c-1.93.64-3.93 1.3-3.85 2.44.1 1.41 8.71 2.21 14.07 2 2-.09 5.64-.51 8.52-.85 2.12-.25 3.8-.45 4.31-.45h.3c1 0 3.8.06 4.9-1.08a1.73 1.73 0 00.46-1.32 18 18 0 00-1.24-5.54 24.8 24.8 0 01-4.22.13c-4.93-.21-10.12-3.37-11.59-4.33z"
          style={{
            WebkitTransformOrigin: 397.372,
            MsTransformOrigin: 397.372,
            transformOrigin: 397.372,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M436 445.06c-1 1.71-2.38 3.87-4.36 4-2.43.17-4.16-1.77-4.94-2.87.53 4.19 1.66 12 4.33 15.16 3.57 4.22 5.85 3.84 8 3.91 2.39.08 5.59-2.12 3.65-8-1.54-4.56-4.89-8.06-6.68-12.2z"
          style={{
            WebkitTransformOrigin: 434.989,
            MsTransformOrigin: 434.989,
            transformOrigin: 434.989,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M439.17 465.76h-.74c-2.07 0-4.42-.07-7.81-4.07-2.62-3.1-3.79-10.29-4.44-15.43l-.26-2 1.16 1.63c.75 1.06 2.33 2.82 4.5 2.66 1.66-.11 2.92-2 4-3.76l.5-.83.39.89a37.64 37.64 0 002.92 5.1 32.33 32.33 0 013.8 7.18c1.2 3.6.45 5.7-.38 6.82a4.49 4.49 0 01-3.64 1.81zm-11.78-18c.67 4.79 1.81 10.65 4 13.23 3.09 3.66 5.11 3.69 7.06 3.72h.6a3.55 3.55 0 002.91-1.4c.7-.93 1.3-2.71.24-5.9a31.28 31.28 0 00-3.69-7 44.59 44.59 0 01-2.59-4.38c-.94 1.49-2.32 3.31-4.28 3.44a5.57 5.57 0 01-4.25-1.67z"
          style={{
            WebkitTransformOrigin: 434.868,
            MsTransformOrigin: 434.868,
            transformOrigin: 434.868,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M397 233.05s.57 8.3.14 9.74-5.44 1.57-6.3 1.29-6.73-1.44-9.59 0-6.59 7.73-7.31 9a16.62 16.62 0 01-2.86 3.15s-5.16-19.91-5.16-21.48a20.73 20.73 0 00-2.29-12.46c-3.29-6.16-5.87-10.17-8.31-12s-4.87-2-5-.57 1 2.29 1.86 3.3a46.9 46.9 0 013 5.44s-5.3 8.74-5.44 10.74-.43 2.43 1 4 6.3 4 6.3 4a71.1 71.1 0 00.72 12.75c1 6-1.58 14.61 2.15 22.05s9 9.17 9.88 8.45 10.17-7.16 10.17-7.16 1.14 14.32 1.29 14.9-.72 4.72 0 6.3 3.15 4.73 16.32 5.44 21.77-1 22.49-2.15.43-3.15.43-4.15 2.15-16.33 2.15-16.33 4.72 11.32 5.3 12.89 1.72 5.88 1.72 5.88-.43 11 1.43 16 4 9.88 4 9.88l2.55 16.39s-1.43 2.86-1.14 4.87.81 6.74.81 7.45 0 2.87 1.15 3.15 2.15-2.72 2.15-2.72a64.37 64.37 0 01.57 6.45c-.14.86 1.34 3.55 2.58.71.46-1.05.86-2.86 1.14-3.43a28.75 28.75 0 002.15-5.73c.43-2.15.62-4.46-1-9.46-.38-1.22-1.57-3.73-1.57-4.16s.74-19.68-.12-27.13a68 68 0 00-3.3-14s-3.43-22.49-3.43-23.35.57-11.31-3.16-16.33-10.31-6-14.32-7a57.29 57.29 0 01-9-3c-.72-.43-.86-9.88-.86-9.88z"
          style={{
            WebkitTransformOrigin: 398.484,
            MsTransformOrigin: 398.484,
            transformOrigin: 398.484,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M442.5 360.06a1.18 1.18 0 01-.35-.05 2.63 2.63 0 01-1.49-2.51 37.83 37.83 0 00-.36-4.51c-.48.83-1.17 1.56-2 1.35-1.53-.38-1.53-2.75-1.53-3.64 0-.63-.5-5.26-.81-7.38-.27-1.89.83-4.39 1.13-5l-2.53-16.17c-.25-.58-2.26-5.18-4-9.85-1.82-4.89-1.5-15.09-1.47-16.16-.15-.57-1.16-4.33-1.68-5.76-.43-1.17-3.25-8-4.59-11.18-.84 6-1.89 13.81-1.89 14.45v.68a6.7 6.7 0 01-.53 3.74c-.91 1.47-10.08 3.08-22.93 2.38-9.77-.53-15.25-2.41-16.76-5.73-.54-1.19-.3-3.44-.13-5.09a10.91 10.91 0 00.1-1.31c-.13-.52-.94-10.5-1.23-14.1-3.35 2.32-8.8 6.12-9.42 6.64a1.9 1.9 0 01-1.59.18c-1.93-.4-6-2.71-9.06-8.79-2.45-4.9-2.24-10.29-2.05-15a36.34 36.34 0 00-.15-7.16 72.61 72.61 0 01-.73-12.53c-1.08-.56-4.87-2.56-6.16-4a3.7 3.7 0 01-1.19-3.66c0-.22 0-.46.06-.73.14-1.94 4.41-9.13 5.37-10.73a41.58 41.58 0 00-2.82-5.09c-.15-.18-.32-.36-.49-.53a4 4 0 01-1.49-3.14 1.47 1.47 0 01.91-1.24c1.14-.49 3.11.1 4.91 1.47 2.31 1.76 4.75 5.3 8.44 12.19a20.32 20.32 0 012.4 11.82c0 .36-.05.65-.05.88 0 1.07 2.88 12.58 4.93 20.55a12.78 12.78 0 002.15-2.46c.18-.31 4.25-7.59 7.52-9.23 3-1.49 8.93-.38 10 0a11.12 11.12 0 005.22-.57.9.9 0 00.45-.39c.29-1 .06-6.26-.17-9.56v-.61l14.35 1.86v.43c.06 4.15.33 8.76.68 9.5a59.94 59.94 0 008.82 2.91l1.46.35c4.11.95 9.74 2.27 13.15 6.86 2.33 3.13 3.45 8.77 3.25 16.31v.25c0 .7 2.05 14.25 3.42 23.22a69.46 69.46 0 013.3 14.1c.51 4.41.56 13.59.15 26.54v.65a18.05 18.05 0 00.7 1.83c.33.79.67 1.6.85 2.18 1.65 5.21 1.4 7.56 1 9.71a29.11 29.11 0 01-2.19 5.85 12.7 12.7 0 00-.44 1.33 17.48 17.48 0 01-.69 2.08c-.62 1.28-1.25 1.57-1.75 1.57zm-1.7-11.16l.27 2.17a53.15 53.15 0 01.57 6.59c-.05.3.36 1.26.79 1.39.22.08.55-.3.84-1a17.31 17.31 0 00.65-2 10.52 10.52 0 01.51-1.5 28.32 28.32 0 002.1-5.6c.4-2 .63-4.22-.94-9.21-.17-.53-.5-1.33-.82-2.1a8.4 8.4 0 01-.78-2.21v-.68c.41-12.72.36-22.09-.14-26.39a67.5 67.5 0 00-3.27-13.92v-.1c-.35-2.3-3.44-22.55-3.44-23.42v-.34c.19-7.2-.89-12.78-3.06-15.69-3.19-4.29-8.61-5.56-12.57-6.48-.52-.12-1-.23-1.47-.35a56.56 56.56 0 01-9.16-3.06c-.23-.14-.93-.56-1.09-9.87l-12.29-1.59c.13 2 .47 8 .08 9.31a1.72 1.72 0 01-.94 1 11.93 11.93 0 01-6 .63c-.94-.31-6.55-1.36-9.21 0-2.49 1.25-6 6.79-7.09 8.82a16.83 16.83 0 01-3 3.29l-.6.53-.21-.79c-.53-2-5.17-20-5.17-21.6 0-.25 0-.57.05-1a19.1 19.1 0 00-2.28-11.28c-3.57-6.67-6-10.22-8.17-11.87-1.66-1.27-3.22-1.63-3.9-1.34a.46.46 0 00-.31.42c-.1.94.52 1.59 1.23 2.35.17.19.35.38.51.57a46.78 46.78 0 013.08 5.55l.12.25-.14.23c-2.11 3.47-5.28 9.13-5.37 10.52 0 .27-.05.52-.07.74a2.77 2.77 0 00.94 2.89c1.35 1.49 6.11 3.88 6.15 3.9l.29.15v.32a72.32 72.32 0 00.71 12.65 36.87 36.87 0 01.16 7.36c-.18 4.63-.39 9.88 1.94 14.55 2.52 5 5.91 7.56 8.05 8.18a1.75 1.75 0 001.07.1c.87-.71 9.82-6.91 10.2-7.18l.72-.49.07.86c.45 5.67 1.16 14.29 1.27 14.82a6 6 0 01-.08 1.65c-.14 1.35-.38 3.62.05 4.56 1.65 3.64 9.56 4.81 15.9 5.15 13.12.71 21.39-1 22-1.91a6.12 6.12 0 00.37-3.16v-.73c0-1 1.93-14.82 2.15-16.4l.25-1.8.71 1.68c.19.46 4.74 11.34 5.31 12.91s1.68 5.74 1.73 5.92v.14c0 .11-.41 11 1.4 15.85s4 9.81 4 9.86v.12l2.58 16.55-.07.14s-1.36 2.75-1.1 4.58.82 6.72.82 7.52c0 2.16.48 2.6.77 2.67s1.12-1.1 1.55-2.4zm-29.31-104.6z"
          style={{
            WebkitTransformOrigin: 398.433,
            MsTransformOrigin: 398.433,
            transformOrigin: 398.433,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M373.09 278.05l6.83-4.76s1.14 14.32 1.29 14.9-.72 4.72 0 6.3 3.15 4.73 16.32 5.44 21.77-1 22.49-2.15.43-3.15.43-4.15 2.15-16.33 2.15-16.33 3.82 9.15 5 12.14a31.62 31.62 0 0012.13-4c-1-6.39-2.09-14-2.09-14.47 0-.86.57-11.31-3.16-16.33s-10.31-6-14.32-7a57.29 57.29 0 01-9-3c-.72-.43-.86-9.88-.86-9.88l-13.3-1.71s.57 8.3.14 9.74-5.44 1.57-6.3 1.29-6.73-1.44-9.59 0-6.59 7.73-7.31 9a16.62 16.62 0 01-2.86 3.15s4.29 5.73 4.15 11.89a25.3 25.3 0 01-2.14 9.93z"
          style={{
            WebkitTransformOrigin: 405.405,
            MsTransformOrigin: 405.405,
            transformOrigin: 405.405,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M403.57 300.6c-1.91 0-3.94-.05-6.06-.17-9.77-.53-15.25-2.41-16.76-5.73-.54-1.19-.3-3.44-.13-5.09a10.91 10.91 0 00.1-1.31c-.13-.52-.94-10.5-1.23-14.1-1.25.87-3.92 2.72-6.11 4.26l-1.58 1.11.84-1.74a24.2 24.2 0 002.05-9.71c.14-5.9-4-11.52-4.05-11.57l-.28-.37.35-.31a16.57 16.57 0 002.75-3c.18-.31 4.25-7.59 7.52-9.23 3-1.49 8.93-.38 10 0a11.12 11.12 0 005.22-.57.9.9 0 00.45-.39c.29-1 .06-6.26-.17-9.56v-.61l14.35 1.86v.43c.06 4.15.33 8.76.68 9.5a59.94 59.94 0 008.82 2.91l1.46.35c4.11.95 9.74 2.27 13.15 6.86 2.33 3.13 3.45 8.77 3.25 16.31v.27c0 .24.28 2.43 2.08 14.39v.34l-.29.17a32 32 0 01-12.32 4l-.38.05-.14-.36c-.86-2.17-3.14-7.65-4.3-10.44-.84 6-1.89 13.81-1.89 14.45v.68a6.7 6.7 0 01-.53 3.74c-.74 1.25-7.25 2.58-16.85 2.58zm-23.22-28.21l.07.86c.45 5.67 1.16 14.29 1.27 14.82a6 6 0 01-.08 1.65c-.14 1.35-.38 3.62.05 4.56 1.65 3.64 9.56 4.81 15.9 5.15 13.12.71 21.39-1 22-1.91a6.12 6.12 0 00.37-3.16v-.73c0-1 1.93-14.82 2.15-16.4l.25-1.8.71 1.68c0 .09 3.55 8.51 4.86 11.78a30.88 30.88 0 0011.26-3.68c-2-13.59-2-14-2-14.21v-.34c.19-7.2-.89-12.78-3.06-15.69-3.19-4.29-8.61-5.56-12.57-6.48-.52-.12-1-.23-1.47-.35a56.56 56.56 0 01-9.16-3.06c-.23-.14-.93-.56-1.09-9.87l-12.29-1.59c.13 2 .47 8 .08 9.31a1.72 1.72 0 01-.94 1 11.93 11.93 0 01-6 .63c-.94-.32-6.55-1.36-9.21 0-2.49 1.25-6 6.79-7.09 8.82a14.77 14.77 0 01-2.64 3c1 1.4 4.12 6.4 4 11.83a27.55 27.55 0 01-1.49 8.51l5.43-3.78z"
          style={{
            WebkitTransformOrigin: 405.315,
            MsTransformOrigin: 405.315,
            transformOrigin: 405.315,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M418.76 247.29a52.4 52.4 0 01-7.62-2.64c-.72-.43-.86-9.88-.86-9.88L397 233.05s.57 8.3.14 9.74-4.5 1.53-5.93 1.35c.05 3.18 1.11 10.44 9.66 12.11 7.31 1.43 14.13-4.71 17.89-8.96z"
          style={{
            WebkitTransformOrigin: 404.985,
            MsTransformOrigin: 404.985,
            transformOrigin: 404.985,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M403 257a11.89 11.89 0 01-2.28-.22c-8.94-1.74-10-9.38-10.06-12.59v-.57l.56.07c1.73.21 5.16-.23 5.4-1 .29-1 .06-6.26-.17-9.56v-.61l14.35 1.86v.43c.06 4.15.33 8.76.68 9.5a56.31 56.31 0 007.44 2.54l.77.22-.53.6c-3.23 3.6-9.34 9.33-16.16 9.33zm-11.32-12.28c.16 3.2 1.48 9.57 9.23 11.08 6.86 1.34 13.37-4.31 16.94-8.21a48.53 48.53 0 01-7-2.47c-.23-.14-.93-.56-1.09-9.87l-12.29-1.59c.13 2 .47 8 .08 9.31-.44 1.53-4.16 1.77-5.86 1.71z"
          style={{
            WebkitTransformOrigin: 405.175,
            MsTransformOrigin: 405.175,
            transformOrigin: 405.175,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 400.11,
            MsTransformOrigin: 400.11,
            transformOrigin: 400.11,
          }}
          fill="#263238"
          d="M403.26 238.49L397.59 238.88 396.96 233.05 403.26 238.49z"
          className="animable"
        ></path>
        <path
          d="M397.14 239.41l-.81-7.57 8.18 7.07zm.45-5.16l.45 4.1 4-.28z"
          style={{
            WebkitTransformOrigin: 400.42,
            MsTransformOrigin: 400.42,
            transformOrigin: 400.42,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M397.75 271.35c-.43-3.2 2.47-14.73 2.59-15.22l1 .24c0 .12-3 11.83-2.57 14.85z"
          style={{
            WebkitTransformOrigin: 399.523,
            MsTransformOrigin: 399.523,
            transformOrigin: 399.523,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M381.13 258.74l-.92-.4a23.4 23.4 0 011.58-3.08l.84.54a23.25 23.25 0 00-1.5 2.94z"
          style={{
            WebkitTransformOrigin: 381.42,
            MsTransformOrigin: 381.42,
            transformOrigin: 381.42,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M379.46 273.51c0-.12-1.33-2.9-1-8.12a19.1 19.1 0 011.09-5.23l.94.32a18.82 18.82 0 00-1 5c-.27 5 .95 7.61 1 7.64z"
          style={{
            WebkitTransformOrigin: 379.449,
            MsTransformOrigin: 379.449,
            transformOrigin: 379.449,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 423.435,
            MsTransformOrigin: 423.435,
            transformOrigin: 423.435,
          }}
          fill="#263238"
          d="M418.58 272.02H428.28999999999996V273.02H418.58z"
          className="animable"
          transform="rotate(-80.1)"
        ></path>
        <path
          d="M402.26 204.83l-9.17 6.3s-.28 3.73-.28 7.74-1.15 7.45.86 11.17 6.3 8.45 9.59 8.45 7.45-1.86 10-3.87 3.86-5.87 3.86-5.87 3.59-1.43 3.3-3.72-.72-3.87-1.29-4-1.86-.43-1.86-.43l-1.86-7.74s-10.57-4.45-13.15-8.03z"
          style={{
            WebkitTransformOrigin: 406.46,
            MsTransformOrigin: 406.46,
            transformOrigin: 406.46,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M403.26 239c-3.68 0-8.09-5.1-10-8.71-1.53-2.84-1.32-5.48-1.09-8.28.08-1 .17-2.06.17-3.13 0-4 .28-7.74.29-7.77v-.24l9.77-6.72.29.4c2.46 3.43 12.85 7.81 13 7.85l.23.1 1.85 7.68 1.57.36c.57.14 1.21.78 1.67 4.43.28 2.32-2.57 3.79-3.4 4.16a14.2 14.2 0 01-4 5.9c-2.47 1.9-6.76 3.97-10.35 3.97zm-9.68-27.58c-.07.88-.27 4.09-.27 7.46 0 1.11-.09 2.18-.17 3.21-.22 2.65-.42 5.15 1 7.72 2.13 4 6.31 8.19 9.15 8.19 3.36 0 7.39-2 9.72-3.76s3.69-5.6 3.7-5.64l.07-.22.22-.08c.89-.36 3.18-1.64 3-3.2-.4-3.24-.91-3.58-.93-3.6l-1.83-.41-.31-.07-1.87-7.8c-1.56-.66-10-4.39-12.85-7.7z"
          style={{
            WebkitTransformOrigin: 406.519,
            MsTransformOrigin: 406.519,
            transformOrigin: 406.519,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M402.67 221.23a2.76 2.76 0 01-1.72-.68 1.25 1.25 0 01-.5-1c0-1.2 1.55-2.67 2.17-3.21v-1.91h1v2.38l-.18.15c-.83.68-2 1.93-2 2.58a.25.25 0 00.11.22 1.55 1.55 0 001.79.32l.36-.12.25 1a1.43 1.43 0 00-.27.09 3 3 0 01-1.01.18z"
          style={{
            WebkitTransformOrigin: 402.2,
            MsTransformOrigin: 402.2,
            transformOrigin: 402.2,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M403.3 227.24a6.2 6.2 0 01-4.27-1.73l.73-.68c.13.14 3.2 3.33 7.92-.34l.62.79a8.16 8.16 0 01-5 1.96z"
          style={{
            WebkitTransformOrigin: 403.665,
            MsTransformOrigin: 403.665,
            transformOrigin: 403.665,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M396.31 213.49l-.71-.7c.09-.09 2.11-2 5.92-1.14l-.24 1c-3.28-.81-4.9.78-4.97.84z"
          style={{
            WebkitTransformOrigin: 398.56,
            MsTransformOrigin: 398.56,
            transformOrigin: 398.56,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M411.22 213.49a5 5 0 00-5.32-1l-.4-.91a5.94 5.94 0 016.42 1.25z"
          style={{
            WebkitTransformOrigin: 408.71,
            MsTransformOrigin: 408.71,
            transformOrigin: 408.71,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M399.82 215.93c0 .67-.38 1.22-.85 1.22s-.86-.55-.86-1.22.38-1.22.86-1.22.85.55.85 1.22z"
          style={{
            WebkitTransformOrigin: 398.965,
            MsTransformOrigin: 398.965,
            transformOrigin: 398.965,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M409.56 215.93c0 .67-.38 1.22-.86 1.22s-.85-.55-.85-1.22.38-1.22.85-1.22.86.55.86 1.22z"
          style={{
            WebkitTransformOrigin: 408.705,
            MsTransformOrigin: 408.705,
            transformOrigin: 408.705,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M392.66 220.73s-2.86-1.58-3 1.29 2.43 5 2.43 5z"
          style={{
            WebkitTransformOrigin: 391.157,
            MsTransformOrigin: 391.157,
            transformOrigin: 391.157,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M392.5 228l-.73-.61c-.11-.1-2.77-2.35-2.61-5.43a2.2 2.2 0 011-2 3.27 3.27 0 012.77.26l.28.16zm-1.39-7.23a1.06 1.06 0 00-.48.1c-.29.16-.44.55-.47 1.14a5.73 5.73 0 001.53 3.87l.44-4.88a3 3 0 00-1.02-.2z"
          style={{
            WebkitTransformOrigin: 391.182,
            MsTransformOrigin: 391.182,
            transformOrigin: 391.182,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M355.14 218.44s-2.81-.84-4 1.59.81 5 2.29 5.94 2.7.68 2.84-1.08-1.62-4-1.62-4z"
          style={{
            WebkitTransformOrigin: 353.528,
            MsTransformOrigin: 353.528,
            transformOrigin: 353.528,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M354.93 227a3.35 3.35 0 01-1.78-.62c-1.82-1.15-3.79-4-2.48-6.58a3.86 3.86 0 014.61-1.85l.44.13-.55 2.64c.43.61 1.7 2.57 1.58 4.2a2.1 2.1 0 01-1 1.9 1.72 1.72 0 01-.82.18zm-.93-8.2a2.6 2.6 0 00-2.47 1.46c-1.12 2.24 1 4.57 2.11 5.29.66.42 1.23.56 1.58.39s.46-.69.49-1.09c.1-1.28-1.06-3.11-1.52-3.7l-.14-.19.46-2.13a3.89 3.89 0 00-.51-.03z"
          style={{
            WebkitTransformOrigin: 353.501,
            MsTransformOrigin: 353.501,
            transformOrigin: 353.501,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M350.58 221.65s-2.57 2-2.3 3.65 3.38 3.78 5 3.64 1.08-2.29 1.08-2.29-3.11-2.97-3.78-5z"
          style={{
            WebkitTransformOrigin: 351.353,
            MsTransformOrigin: 351.353,
            transformOrigin: 351.353,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M353.14 229.45c-1.85 0-5-2.17-5.35-4.07s2.19-3.89 2.48-4.12l.56-.44.22.67c.63 1.89 3.62 4.77 3.66 4.8l.1.1v.14a3 3 0 01-.27 2.24 1.63 1.63 0 01-1.25.67zm-2.75-7c-.73.7-1.75 1.88-1.61 2.74.21 1.29 3 3.32 4.46 3.22a.62.62 0 00.52-.25 2 2 0 00.14-1.29 20.62 20.62 0 01-3.51-4.39z"
          style={{
            WebkitTransformOrigin: 351.336,
            MsTransformOrigin: 351.336,
            transformOrigin: 351.336,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M349.09 227.05s-2 1.49-.94 3.38 3.91 2.43 4.86 1.35.27-2.84.27-2.84-4.05-.94-4.19-1.89z"
          style={{
            WebkitTransformOrigin: 350.678,
            MsTransformOrigin: 350.678,
            transformOrigin: 350.678,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M351.52 232.83h-.4a4.55 4.55 0 01-3.41-2.13 3.13 3.13 0 011.09-4l.67-.49.12.8c.19.37 2 1.07 3.8 1.5l.26.06.1.24c0 .09.77 2.05-.36 3.35a2.46 2.46 0 01-1.87.67zm-2.5-5a2 2 0 00-.44 2.39 3.53 3.53 0 002.64 1.63 1.68 1.68 0 001.41-.36 2.4 2.4 0 00.26-2.09 10.52 10.52 0 01-3.89-1.61z"
          style={{
            WebkitTransformOrigin: 350.697,
            MsTransformOrigin: 350.697,
            transformOrigin: 350.697,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M361 233.4a9 9 0 01-1.08-4.59c.14-2.57 2.43-5.81 2.43-5.81a13.68 13.68 0 01-.67-2.16c-.27-1.21-1.89-5.67-.41-7.56s2.7 1.22 3.65 4.05 1.62 4.32 1.62 4.32a13.29 13.29 0 01.54 5.81c-.54 2.56-2 7.15-2 7.15"
          style={{
            WebkitTransformOrigin: 363.552,
            MsTransformOrigin: 363.552,
            transformOrigin: 363.552,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M365.5 234.77l-.95-.31c0-.05 1.48-4.6 2-7.11a12.8 12.8 0 00-.52-5.54 45.65 45.65 0 01-1.62-4.32c-.35-1-1.38-4.14-2.22-4.28-.21 0-.44.22-.56.38-1.1 1.39-.17 4.73.28 6.33.1.34.17.62.22.81a12 12 0 00.65 2.08l.1.25-.16.23s-2.21 3.16-2.34 5.54a8.5 8.5 0 001 4.31l-.85.52a9.22 9.22 0 01-1.15-4.88c.12-2.31 1.83-5 2.36-5.84a15.52 15.52 0 01-.6-2c0-.18-.11-.45-.2-.76-.53-1.9-1.52-5.42-.11-7.22a1.61 1.61 0 011.52-.75c1.19.21 2 2.05 3 4.95s1.6 4.26 1.6 4.28a13.48 13.48 0 01.58 6.11c-.53 2.57-1.97 7.03-2.03 7.22z"
          style={{
            WebkitTransformOrigin: 363.512,
            MsTransformOrigin: 363.512,
            transformOrigin: 363.512,
          }}
          fill="#263238"
          className="animable"
        ></path>
      </g>
      <g
        className="animable"
        style={{
          WebkitTransformOrigin: 266.74,
          MsTransformOrigin: 266.74,
          transformOrigin: 266.74,
        }}
      >
        <path
          style={{
            WebkitTransformOrigin: 279.96,
            MsTransformOrigin: 279.96,
            transformOrigin: 279.96,
          }}
          fill="#263238"
          d="M240.25 364.5H319.67V365.5H240.25z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 233.23,
            MsTransformOrigin: 233.23,
            transformOrigin: 233.23,
          }}
          fill="#4CB967"
          d="M230.57 361.61H235.89V366.93H230.57z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 279.96,
            MsTransformOrigin: 279.96,
            transformOrigin: 279.96,
          }}
          fill="#263238"
          d="M240.25 376.12H319.67V377.12H240.25z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 233.23,
            MsTransformOrigin: 233.23,
            transformOrigin: 233.23,
          }}
          fill="#4CB967"
          d="M230.57 373.22H235.89V378.54H230.57z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 279.96,
            MsTransformOrigin: 279.96,
            transformOrigin: 279.96,
          }}
          fill="#263238"
          d="M240.25 387.73H319.67V388.73H240.25z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 233.23,
            MsTransformOrigin: 233.23,
            transformOrigin: 233.23,
          }}
          fill="#4CB967"
          d="M230.57 384.83H235.89V390.15H230.57z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 279.96,
            MsTransformOrigin: 279.96,
            transformOrigin: 279.96,
          }}
          fill="#263238"
          d="M240.25 399.34H319.67V400.34H240.25z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 233.23,
            MsTransformOrigin: 233.23,
            transformOrigin: 233.23,
          }}
          fill="#4CB967"
          d="M230.57 396.45H235.89V401.77H230.57z"
          className="animable"
        ></path>
        <path
          d="M364.74 421.84h-196V299.89h196zm-195-1h194V300.89h-194z"
          style={{
            WebkitTransformOrigin: 266.74,
            MsTransformOrigin: 266.74,
            transformOrigin: 266.74,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M364.74 310.61h-196v-10.72h196zm-195-1h194v-8.72h-194z"
          style={{
            WebkitTransformOrigin: 266.74,
            MsTransformOrigin: 266.74,
            transformOrigin: 266.74,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 220.33,
            MsTransformOrigin: 220.33,
            transformOrigin: 220.33,
          }}
          fill="#263238"
          d="M219.83 310.79H220.83V420.31H219.83z"
          className="animable"
        ></path>
        <path
          d="M246.43 353.05a17.33 17.33 0 1117.33-17.33 17.34 17.34 0 01-17.33 17.33zm0-33.66a16.33 16.33 0 1016.33 16.33 16.34 16.34 0 00-16.33-16.33z"
          style={{
            WebkitTransformOrigin: 246.43,
            MsTransformOrigin: 246.43,
            transformOrigin: 246.43,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M246.43 340.27a6.47 6.47 0 116.47-6.47 6.48 6.48 0 01-6.47 6.47zm0-11.94a5.47 5.47 0 105.47 5.47 5.48 5.48 0 00-5.47-5.47z"
          style={{
            WebkitTransformOrigin: 246.43,
            MsTransformOrigin: 246.43,
            transformOrigin: 246.43,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M246.43 353.05a17.11 17.11 0 01-10.43-3.51l-.25-.18.05-.3a10.77 10.77 0 0121.24 0l.05.3-.25.18a17.11 17.11 0 01-10.41 3.51zm-9.57-4.12a16.25 16.25 0 0019.15 0 9.76 9.76 0 00-19.15 0z"
          style={{
            WebkitTransformOrigin: 246.42,
            MsTransformOrigin: 246.42,
            transformOrigin: 246.42,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M195.19 343.08a8.6 8.6 0 118.59-8.59 8.6 8.6 0 01-8.59 8.59zm0-16.19a7.6 7.6 0 107.59 7.6 7.61 7.61 0 00-7.59-7.6z"
          style={{
            WebkitTransformOrigin: 195.18,
            MsTransformOrigin: 195.18,
            transformOrigin: 195.18,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M195.19 336.94a3.37 3.37 0 113.37-3.37 3.38 3.38 0 01-3.37 3.37zm0-5.74a2.37 2.37 0 102.37 2.37 2.37 2.37 0 00-2.37-2.37z"
          style={{
            WebkitTransformOrigin: 195.19,
            MsTransformOrigin: 195.19,
            transformOrigin: 195.19,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M195.19 343.08a8.53 8.53 0 01-5.17-1.73l-.25-.19v-.3a5.44 5.44 0 0110.73 0v.3l-.24.19a8.58 8.58 0 01-5.07 1.73zm-4.32-2.35a7.68 7.68 0 008.63 0 4.44 4.44 0 00-8.63 0z"
          style={{
            WebkitTransformOrigin: 195.135,
            MsTransformOrigin: 195.135,
            transformOrigin: 195.135,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M195.19 377a8.6 8.6 0 118.59-8.6 8.61 8.61 0 01-8.59 8.6zm0-16.2a7.6 7.6 0 107.59 7.6 7.61 7.61 0 00-7.59-7.61z"
          style={{
            WebkitTransformOrigin: 195.18,
            MsTransformOrigin: 195.18,
            transformOrigin: 195.18,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M195.19 370.84a3.37 3.37 0 113.37-3.37 3.37 3.37 0 01-3.37 3.37zm0-5.74a2.37 2.37 0 102.37 2.37 2.37 2.37 0 00-2.37-2.37z"
          style={{
            WebkitTransformOrigin: 195.19,
            MsTransformOrigin: 195.19,
            transformOrigin: 195.19,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M195.19 377a8.54 8.54 0 01-5.17-1.74l-.25-.19v-.29a5.44 5.44 0 0110.73 0v.29l-.24.19a8.59 8.59 0 01-5.07 1.74zm-4.32-2.36a7.66 7.66 0 008.63 0 4.44 4.44 0 00-8.63 0z"
          style={{
            WebkitTransformOrigin: 195.135,
            MsTransformOrigin: 195.135,
            transformOrigin: 195.135,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M195.19 410.89a8.6 8.6 0 118.59-8.6 8.61 8.61 0 01-8.59 8.6zm0-16.2a7.6 7.6 0 107.59 7.6 7.61 7.61 0 00-7.59-7.6z"
          style={{
            WebkitTransformOrigin: 195.18,
            MsTransformOrigin: 195.18,
            transformOrigin: 195.18,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M195.19 404.74a3.37 3.37 0 113.37-3.37 3.37 3.37 0 01-3.37 3.37zm0-5.74a2.37 2.37 0 102.37 2.37 2.37 2.37 0 00-2.37-2.37z"
          style={{
            WebkitTransformOrigin: 195.19,
            MsTransformOrigin: 195.19,
            transformOrigin: 195.19,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M195.19 410.89a8.48 8.48 0 01-5.17-1.74l-.25-.19v-.29a5.44 5.44 0 0110.73 0v.29l-.24.19a8.52 8.52 0 01-5.07 1.74zm-4.32-2.36a7.66 7.66 0 008.63 0 4.44 4.44 0 00-8.63 0z"
          style={{
            WebkitTransformOrigin: 195.135,
            MsTransformOrigin: 195.135,
            transformOrigin: 195.135,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 293.625,
            MsTransformOrigin: 293.625,
            transformOrigin: 293.625,
          }}
          fill="#263238"
          d="M272.32 325.63H314.93V326.63H272.32z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 293.625,
            MsTransformOrigin: 293.625,
            transformOrigin: 293.625,
          }}
          fill="#263238"
          d="M272.32 335.43H314.93V336.43H272.32z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 293.625,
            MsTransformOrigin: 293.625,
            transformOrigin: 293.625,
          }}
          fill="#263238"
          d="M272.32 345.23H314.93V346.23H272.32z"
          className="animable"
        ></path>
      </g>
      <g
        className="animable"
        style={{
          WebkitTransformOrigin: 300.5,
          MsTransformOrigin: 300.5,
          transformOrigin: 300.5,
        }}
      >
        <path
          d="M368 266.86H233V68.31h135zm-134-1h133V69.31H234z"
          style={{
            WebkitTransformOrigin: 300.5,
            MsTransformOrigin: 300.5,
            transformOrigin: 300.5,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <circle
          cx="297.08"
          cy="130.84"
          r="42.92"
          style={{
            WebkitTransformOrigin: 297.08,
            MsTransformOrigin: 297.08,
            transformOrigin: 297.08,
          }}
          fill="#FFF"
          className="animable"
        ></circle>
        <path
          d="M297.08 174.26a43.42 43.42 0 1143.42-43.42 43.47 43.47 0 01-43.42 43.42zm0-85.83a42.42 42.42 0 1042.42 42.41 42.46 42.46 0 00-42.42-42.41z"
          style={{
            WebkitTransformOrigin: 297.08,
            MsTransformOrigin: 297.08,
            transformOrigin: 297.08,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 297.845,
            MsTransformOrigin: 297.845,
            transformOrigin: 297.845,
          }}
          fill="#263238"
          d="M252.63 187.1H343.06V188.1H252.63z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 297.845,
            MsTransformOrigin: 297.845,
            transformOrigin: 297.845,
          }}
          fill="#263238"
          d="M252.63 196.3H343.06V197.3H252.63z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 303.35,
            MsTransformOrigin: 303.35,
            transformOrigin: 303.35,
          }}
          fill="#263238"
          d="M263.64 211.78H343.06V212.78H263.64z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 256.63,
            MsTransformOrigin: 256.63,
            transformOrigin: 256.63,
          }}
          fill="#4CB967"
          d="M253.97 208.88H259.29V214.2H253.97z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 303.35,
            MsTransformOrigin: 303.35,
            transformOrigin: 303.35,
          }}
          fill="#263238"
          d="M263.64 223.39H343.06V224.39H263.64z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 256.63,
            MsTransformOrigin: 256.63,
            transformOrigin: 256.63,
          }}
          fill="#4CB967"
          d="M253.97 220.5H259.29V225.82H253.97z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 303.35,
            MsTransformOrigin: 303.35,
            transformOrigin: 303.35,
          }}
          fill="#263238"
          d="M263.64 235H343.06V236H263.64z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 256.63,
            MsTransformOrigin: 256.63,
            transformOrigin: 256.63,
          }}
          fill="#4CB967"
          d="M253.97 232.11H259.29V237.43H253.97z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 303.35,
            MsTransformOrigin: 303.35,
            transformOrigin: 303.35,
          }}
          fill="#263238"
          d="M263.64 246.61H343.06V247.61H263.64z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 256.63,
            MsTransformOrigin: 256.63,
            transformOrigin: 256.63,
          }}
          fill="#4CB967"
          d="M253.97 243.72H259.29V249.04H253.97z"
          className="animable"
        ></path>
        <path
          d="M287.59 102.37a20.59 20.59 0 0118-9.22c12.42.4 15.43 14 15 18a19.15 19.15 0 01-1.81 6.62l-5.41-4.61a37.17 37.17 0 018.46 13.06c3 8 1.56 18.39-2.25 20.8s-6.41 1.4-6.41 1.4l.4-5.41s-3.6 6.41-9.61 7.61-23.24 2-25.85-1a14.84 14.84 0 01-3.2-6.41l-.4 5.21s-5.41-4-5.61-8.62 2.6-11 4-14.42 2.4-5.21 2.8-10.42-.2-8 3.41-11.42 8.48-1.17 8.48-1.17z"
          style={{
            WebkitTransformOrigin: 296.166,
            MsTransformOrigin: 296.166,
            transformOrigin: 296.166,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M290.17 152.22c-5.61 0-10.91-.56-12.37-2.24a15.2 15.2 0 01-2.53-4.12l-.2 2.63a.51.51 0 01-.29.41.49.49 0 01-.51-.05c-.23-.17-5.6-4.2-5.81-9-.19-4.42 2.28-10.38 3.76-13.94l.28-.69.49-1.16a24.46 24.46 0 002.28-9.11c.07-.91.11-1.74.15-2.52.17-3.64.29-6.28 3.41-9.22s7.28-1.93 8.56-1.46a21.35 21.35 0 0118.25-9.1 14.27 14.27 0 0110.66 5c3.8 4.34 5.14 10.68 4.84 13.6a19.39 19.39 0 01-1.86 6.8.47.47 0 01-.34.26.51.51 0 01-.42-.11l-.73-.63a37.76 37.76 0 014.57 8.52c3 8 1.74 18.75-2.45 21.4-4 2.51-6.74 1.49-6.86 1.44a.49.49 0 01-.31-.5l.26-3.51c-1.52 2-4.59 5.38-8.88 6.24a84.44 84.44 0 01-13.95 1.06zM275 142.74a.49.49 0 01.49.41 14.61 14.61 0 003.09 6.17c2.3 2.66 18.63 2.19 25.37.84 5.71-1.14 9.24-7.3 9.28-7.37a.5.5 0 01.93.29l-.37 5c.79.16 2.84.31 5.62-1.45 3.43-2.16 5.08-12.11 2-20.2a37 37 0 00-8.33-12.87.5.5 0 010-.69.49.49 0 01.7 0l4.91 4.18a20 20 0 001.48-5.86 19.75 19.75 0 00-4.6-12.84 13.3 13.3 0 00-9.94-4.64 20.35 20.35 0 00-17.59 9 .5.5 0 01-.64.2c-.18-.08-4.55-2-7.86 1.11-2.83 2.67-2.93 4.89-3.1 8.55 0 .79-.08 1.63-.15 2.55a25.17 25.17 0 01-2.36 9.42c-.15.36-.32.74-.48 1.15l-.29.7c-1.45 3.48-3.86 9.31-3.68 13.51.14 3.32 3.24 6.39 4.68 7.64l.33-4.25a.5.5 0 01.47-.46z"
          style={{
            WebkitTransformOrigin: 296.229,
            MsTransformOrigin: 296.229,
            transformOrigin: 296.229,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M279.22 157c-3.32 1.43-8.69 2.7-12.34 4.33a42.9 42.9 0 0060.26.14 22.59 22.59 0 00-4.39-1.62c-6.42-1.78-15.54-7-16.61-8.78s-2.12-8-2.12-8l-14.83-2s.74 7.76.74 9.19-5.71 4.6-10.71 6.74z"
          style={{
            WebkitTransformOrigin: 297.01,
            MsTransformOrigin: 297.01,
            transformOrigin: 297.01,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M297.08 174.26a43.12 43.12 0 01-30.55-12.57.51.51 0 01-.14-.45.47.47 0 01.28-.36 63.28 63.28 0 016.77-2.4c2.09-.66 4.05-1.28 5.59-1.94 6.44-2.76 10.4-5.54 10.4-6.32 0-1.39-.73-9.06-.73-9.14a.49.49 0 01.15-.41.51.51 0 01.41-.13l14.83 2a.5.5 0 01.42.42c0 .06 1.05 6.17 2.06 7.86.91 1.52 9.63 6.7 16.31 8.55a24.24 24.24 0 014.49 1.65.51.51 0 01.12.8 43.17 43.17 0 01-30.41 12.44zm-29.32-12.76a42.41 42.41 0 0058.52.1 25.89 25.89 0 00-3.66-1.26c-6.27-1.74-15.71-7-16.9-9-1-1.61-1.88-6.46-2.13-7.85l-13.84-1.87c.17 1.89.68 7.4.68 8.61 0 2.49-10.56 7.05-11 7.24-1.58.68-3.57 1.3-5.67 2s-4.21 1.28-6 2.03zm11.47-4.5z"
          style={{
            WebkitTransformOrigin: 297.007,
            MsTransformOrigin: 297.007,
            transformOrigin: 297.007,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M285.39 123.81s1.2-9 4-13.83 8.82-3.4 11.22-1.8S306.82 118.4 309 124s3.2 8.81 3.2 8.81-3.46 7.3-8.2 10.19c-5 3.12-10.52 3-14.83-2a22.79 22.79 0 01-3.6-5.8s-5-1.61-6.21-5.81-.2-6.42 1.8-7 4.23 1.42 4.23 1.42z"
          style={{
            WebkitTransformOrigin: 295.519,
            MsTransformOrigin: 295.519,
            transformOrigin: 295.519,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M297.36 145.63a11.16 11.16 0 01-8.55-4.27 23.62 23.62 0 01-3.6-5.74c-1-.37-5.19-2.12-6.31-6.07-1.66-5.8.94-7.27 2.14-7.63a4.93 4.93 0 014 1c.37-2.38 1.6-9.14 3.94-13.16a6.81 6.81 0 014.49-3.35 10.31 10.31 0 017.44 1.38c2.88 1.93 7.31 12.78 8.6 16.06 2.19 5.57 3.21 8.82 3.22 8.85a.48.48 0 010 .37c-.14.3-3.61 7.46-8.4 10.42a13.08 13.08 0 01-6.97 2.14zM282 122.79a2.43 2.43 0 00-.65.09c-1.95.59-2.47 2.86-1.46 6.4 1.11 3.9 5.83 5.45 5.88 5.47a.47.47 0 01.31.29 22.81 22.81 0 003.52 5.67c3.87 4.49 8.91 5.17 14.19 1.9 4.14-2.56 7.37-8.71 7.93-9.83-.24-.77-1.26-3.82-3.13-8.59-2.6-6.62-6.13-14.2-8.22-15.59a9.31 9.31 0 00-6.67-1.24 5.81 5.81 0 00-3.84 2.87c-2.73 4.67-3.94 13.55-3.95 13.64a.48.48 0 01-.32.4.5.5 0 01-.51-.09 5.55 5.55 0 00-3.08-1.39z"
          style={{
            WebkitTransformOrigin: 295.564,
            MsTransformOrigin: 295.564,
            transformOrigin: 295.564,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M300.66 130.61a3.91 3.91 0 01-1-.11.5.5 0 11.21-1 2.2 2.2 0 002.41-.71 2.24 2.24 0 00-.32-2.52 9.44 9.44 0 01-1.5-5.53.5.5 0 111 .06 8.57 8.57 0 001.31 4.89 3.19 3.19 0 01.35 3.65 2.9 2.9 0 01-2.46 1.27z"
          style={{
            WebkitTransformOrigin: 301.395,
            MsTransformOrigin: 301.395,
            transformOrigin: 301.395,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M298.6 134.91a7.07 7.07 0 01-6.65-4.27.5.5 0 01.22-.67.52.52 0 01.68.22c2.94 5.89 9.09 3.1 9.35 3a.5.5 0 01.67.24.5.5 0 01-.24.66 10.57 10.57 0 01-4.03.82z"
          style={{
            WebkitTransformOrigin: 297.406,
            MsTransformOrigin: 297.406,
            transformOrigin: 297.406,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M293.6 124c0 .88.36 1.6.8 1.6s.8-.72.8-1.6-.36-1.61-.8-1.61-.8.73-.8 1.61z"
          style={{
            WebkitTransformOrigin: 294.4,
            MsTransformOrigin: 294.4,
            transformOrigin: 294.4,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M303.42 124c0 .88.36 1.6.8 1.6s.8-.72.8-1.6-.36-1.61-.8-1.61-.8.73-.8 1.61z"
          style={{
            WebkitTransformOrigin: 304.22,
            MsTransformOrigin: 304.22,
            transformOrigin: 304.22,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M291.4 118.1a.5.5 0 01-.34-.87 4.13 4.13 0 015.24-.64.5.5 0 11-.59.81 3.13 3.13 0 00-4 .56.47.47 0 01-.31.14z"
          style={{
            WebkitTransformOrigin: 293.702,
            MsTransformOrigin: 293.702,
            transformOrigin: 293.702,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M301.81 117.89a.54.54 0 01-.33-.12.51.51 0 010-.71 3.84 3.84 0 014.39-.92.5.5 0 11-.42.91 2.85 2.85 0 00-3.22.68.51.51 0 01-.42.16z"
          style={{
            WebkitTransformOrigin: 303.749,
            MsTransformOrigin: 303.749,
            transformOrigin: 303.749,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M313.26 155.9l-15.54 14.73-15.06-15.22c-1.13.56-2.3 1.1-3.44 1.59-3.32 1.43-8.69 2.7-12.34 4.33a42.9 42.9 0 0060.26.14 22.59 22.59 0 00-4.39-1.62 50.79 50.79 0 01-9.49-3.95z"
          style={{
            WebkitTransformOrigin: 297.01,
            MsTransformOrigin: 297.01,
            transformOrigin: 297.01,
          }}
          fill="#4CB967"
          className="animable"
        ></path>
        <path
          d="M297.08 174.26a43.12 43.12 0 01-30.55-12.57l-.52-.52.66-.29a63.28 63.28 0 016.77-2.4c2.09-.66 4.05-1.28 5.59-1.94 1.11-.48 2.26-1 3.4-1.58l.33-.16 15 15.13 15.44-14.64.32.17a50 50 0 009.39 3.91 24.24 24.24 0 014.49 1.65l.61.32-.49.48a43.17 43.17 0 01-30.44 12.44zm-29.32-12.76a42.41 42.41 0 0058.52.1 25.89 25.89 0 00-3.66-1.26 52.5 52.5 0 01-9.28-3.83l-15.63 14.82L282.56 156c-1.06.52-2.11 1-3.14 1.44-1.58.68-3.57 1.3-5.67 2s-4.2 1.31-5.99 2.06z"
          style={{
            WebkitTransformOrigin: 297.01,
            MsTransformOrigin: 297.01,
            transformOrigin: 297.01,
          }}
          fill="#263238"
          className="animable"
        ></path>
      </g>
      <g
        className="animable"
        style={{
          WebkitTransformOrigin: 164.66,
          MsTransformOrigin: 164.66,
          transformOrigin: 164.66,
        }}
      >
        <path
          d="M213.63 266.86h-135V68.31h135zm-134-1h133V69.31h-133z"
          style={{
            WebkitTransformOrigin: 146.13,
            MsTransformOrigin: 146.13,
            transformOrigin: 146.13,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 143.495,
            MsTransformOrigin: 143.495,
            transformOrigin: 143.495,
          }}
          fill="#263238"
          d="M98.28 187.1H188.71V188.1H98.28z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 143.495,
            MsTransformOrigin: 143.495,
            transformOrigin: 143.495,
          }}
          fill="#263238"
          d="M98.28 196.3H188.71V197.3H98.28z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 149.01,
            MsTransformOrigin: 149.01,
            transformOrigin: 149.01,
          }}
          fill="#263238"
          d="M109.3 211.78H188.72V212.78H109.3z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 102.28,
            MsTransformOrigin: 102.28,
            transformOrigin: 102.28,
          }}
          fill="#4CB967"
          d="M99.62 208.88H104.94V214.2H99.62z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 149.01,
            MsTransformOrigin: 149.01,
            transformOrigin: 149.01,
          }}
          fill="#263238"
          d="M109.3 223.39H188.72V224.39H109.3z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 102.28,
            MsTransformOrigin: 102.28,
            transformOrigin: 102.28,
          }}
          fill="#4CB967"
          d="M99.62 220.5H104.94V225.82H99.62z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 149.01,
            MsTransformOrigin: 149.01,
            transformOrigin: 149.01,
          }}
          fill="#263238"
          d="M109.3 235H188.72V236H109.3z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 102.28,
            MsTransformOrigin: 102.28,
            transformOrigin: 102.28,
          }}
          fill="#4CB967"
          d="M99.62 232.11H104.94V237.43H99.62z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 149.01,
            MsTransformOrigin: 149.01,
            transformOrigin: 149.01,
          }}
          fill="#263238"
          d="M109.3 246.61H188.72V247.61H109.3z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 102.28,
            MsTransformOrigin: 102.28,
            transformOrigin: 102.28,
          }}
          fill="#4CB967"
          d="M99.62 243.72H104.94V249.04H99.62z"
          className="animable"
        ></path>
        <circle
          cx="142.74"
          cy="130.84"
          r="42.92"
          style={{
            WebkitTransformOrigin: 142.74,
            MsTransformOrigin: 142.74,
            transformOrigin: 142.74,
          }}
          fill="#FFF"
          className="animable"
        ></circle>
        <path
          d="M142.74 174.26a43.42 43.42 0 1143.41-43.42 43.47 43.47 0 01-43.41 43.42zm0-85.83a42.42 42.42 0 1042.41 42.41 42.46 42.46 0 00-42.41-42.41z"
          style={{
            WebkitTransformOrigin: 142.73,
            MsTransformOrigin: 142.73,
            transformOrigin: 142.73,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M120.4 149.68l-10.7 8.56a42.9 42.9 0 0065.52.63L159 148.26z"
          style={{
            WebkitTransformOrigin: 142.46,
            MsTransformOrigin: 142.46,
            transformOrigin: 142.46,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M142.74 174.26a43.3 43.3 0 01-33.42-15.7.52.52 0 01-.12-.37.49.49 0 01.19-.34l10.69-8.56a.48.48 0 01.3-.11l38.56-1.42a.49.49 0 01.29.08l16.27 10.61a.51.51 0 01.22.35.49.49 0 01-.12.4 43.39 43.39 0 01-32.86 15.06zm-32.33-15.95a42.4 42.4 0 0064.06.66l-15.65-10.2-38.24 1.4z"
          style={{
            WebkitTransformOrigin: 142.462,
            MsTransformOrigin: 142.462,
            transformOrigin: 142.462,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M133.83 137.56s-9.43 1.22-12.06 5.06-4.54 7.52-2.62 9.79a69.31 69.31 0 0010.49 9.26c3.14 2.1 8.05 9.27 8.05 9.27a85.92 85.92 0 00.69-9.09c0-3.85-3.32-8-4-11.54s5.07-9.08 9.08-7.34 7.17 7 7 9.44.69 5.42 1.57 9.61 1.57 7.79 1.57 7.79 5.94-6 7.87-12.51 1-13.1-6.12-17.47-21.52-2.27-21.52-2.27z"
          style={{
            WebkitTransformOrigin: 140.358,
            MsTransformOrigin: 140.358,
            transformOrigin: 140.358,
          }}
          fill="#4CB967"
          className="animable"
        ></path>
        <path
          d="M137.69 171.44a.51.51 0 01-.41-.21c-.05-.07-4.89-7.12-7.92-9.14a70.62 70.62 0 01-10.59-9.36c-2.19-2.58 0-6.52 2.59-10.39s12-5.22 12.4-5.28c.65-.09 14.61-2.06 21.83 2.34 8.19 5 8 12.57 6.34 18-1.94 6.51-7.75 12.46-8 12.71a.5.5 0 01-.85-.25s-.7-3.59-1.57-7.78c-.2-.95-.4-1.84-.58-2.67a26.2 26.2 0 01-1-7.08c.16-2.26-2.84-7.27-6.69-8.95-1.55-.67-3.6-.15-5.51 1.39s-3.2 3.87-2.89 5.4a21.1 21.1 0 001.79 4.58c1.1 2.31 2.24 4.71 2.24 7a89.74 89.74 0 01-.69 9.16.51.51 0 01-.38.42zm3.93-33.88a60.14 60.14 0 00-7.71.49c-.09 0-9.25 1.24-11.71 4.86-2.3 3.37-4.42 7.1-2.66 9.18a69.45 69.45 0 0010.39 9.17c2.47 1.65 5.92 6.23 7.43 8.33.2-1.79.53-5.12.53-7.74 0-2.12-1.09-4.41-2.14-6.62a21.36 21.36 0 01-1.87-4.82c-.45-2.23 1.3-4.8 3.24-6.37 2.2-1.77 4.65-2.35 6.53-1.52 4.29 1.86 7.48 7.34 7.29 9.93a25.69 25.69 0 001 6.79c.19.84.39 1.73.59 2.68.6 2.89 1.12 5.48 1.38 6.83 1.59-1.77 5.6-6.58 7.09-11.59s1.74-12.24-5.9-16.91c-3.58-2.16-9.01-2.69-13.48-2.69zm-7.79 0z"
          style={{
            WebkitTransformOrigin: 140.359,
            MsTransformOrigin: 140.359,
            transformOrigin: 140.359,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M158.42 142.22a16.82 16.82 0 00-3.09-2.39c-7.17-4.37-21.5-2.27-21.5-2.27s-9.43 1.22-12.06 5.06c-.3.45-.6.9-.88 1.34a9.46 9.46 0 001.58 6.7c3.92 6.24 12 9.23 15.89 11-.12-3.78-3.32-7.88-4-11.31s5.07-9.08 9.08-7.34 7.17 7 7 9.44.69 5.42 1.57 9.61l.15.76c.3-.29.6-.59.9-.93a22.77 22.77 0 005.94-15.6 14.82 14.82 0 00-.58-4.07z"
          style={{
            WebkitTransformOrigin: 139.899,
            MsTransformOrigin: 139.899,
            transformOrigin: 139.899,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M152.16 163.28a.4.4 0 01-.15 0 .47.47 0 01-.34-.38l-.15-.74c-.2-.95-.4-1.84-.58-2.67a26.2 26.2 0 01-1-7.08c.16-2.26-2.84-7.27-6.69-8.95-1.55-.67-3.6-.15-5.51 1.39s-3.2 3.87-2.89 5.4a21.1 21.1 0 001.79 4.58c1.05 2.23 2.15 4.54 2.22 6.8a.48.48 0 01-.22.44.51.51 0 01-.48 0l-1.36-.6c-4.18-1.81-11.17-4.85-14.75-10.55a10 10 0 01-1.65-7.05.62.62 0 01.07-.19c.29-.45.58-.9.89-1.35 2.72-4 12-5.23 12.41-5.28.58-.09 14.58-2.07 21.82 2.34a17.42 17.42 0 013.18 2.47.57.57 0 01.13.21 15.19 15.19 0 01.6 4.21 23.13 23.13 0 01-6.07 15.89c-.31.35-.62.66-.92 1a.52.52 0 01-.35.11zm-10.35-21.13a4.47 4.47 0 011.83.37c4.29 1.86 7.48 7.34 7.29 9.93a25.69 25.69 0 001 6.79c.18.79.37 1.63.55 2.52l.23-.25a22.19 22.19 0 005.81-15.22 14.11 14.11 0 00-.53-3.8 16.68 16.68 0 00-2.9-2.24c-6.93-4.22-21-2.22-21.16-2.2s-9.26 1.24-11.72 4.86c-.29.41-.56.82-.82 1.23a9.05 9.05 0 001.53 6.26c3.41 5.44 10.23 8.4 14.3 10.16l.59.26a21.27 21.27 0 00-2.06-5.59 21.79 21.79 0 01-1.86-4.82c-.45-2.23 1.3-4.8 3.24-6.37a7.71 7.71 0 014.68-1.89z"
          style={{
            WebkitTransformOrigin: 139.902,
            MsTransformOrigin: 139.902,
            transformOrigin: 139.902,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M132.26 130.74s1.05 12.58 1.4 16.08 2.27 12.41 8.21 14.15 9.44-5.06 8.57-10.13-2.44-9.79-2.44-11.54a8.52 8.52 0 00-.18-2.27z"
          style={{
            WebkitTransformOrigin: 141.416,
            MsTransformOrigin: 141.416,
            transformOrigin: 141.416,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M143.74 161.76a6.88 6.88 0 01-2-.31c-5.78-1.7-8.11-10-8.57-14.58-.35-3.46-1.39-16-1.4-16.09a.5.5 0 01.2-.44.48.48 0 01.49-.06l15.54 6.29a.48.48 0 01.29.3 9.11 9.11 0 01.2 2.43 27.17 27.17 0 00.93 4.6c.48 1.95 1.08 4.38 1.51 6.85a10.65 10.65 0 01-3 9.37 6.17 6.17 0 01-4.19 1.64zm-10.91-30.25c.23 2.84 1 12.32 1.33 15.26.43 4.37 2.58 12.17 7.85 13.73a5.28 5.28 0 005.23-1.13 9.72 9.72 0 002.7-8.45c-.42-2.43-1-4.74-1.49-6.78a26.26 26.26 0 01-1-4.84 13.14 13.14 0 00-.11-1.9z"
          style={{
            WebkitTransformOrigin: 141.426,
            MsTransformOrigin: 141.426,
            transformOrigin: 141.426,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M147.81 137l-15.55-6.29s.8 9.57 1.23 14.34L148 139a8 8 0 00-.19-2z"
          style={{
            WebkitTransformOrigin: 140.132,
            MsTransformOrigin: 140.132,
            transformOrigin: 140.132,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M133.49 145.58a.45.45 0 01-.25-.07.49.49 0 01-.24-.39c-.44-4.76-1.24-14.34-1.24-14.34a.5.5 0 01.2-.44.48.48 0 01.49-.06l15.55 6.29a.47.47 0 01.29.31 8.1 8.1 0 01.19 2.08.49.49 0 01-.3.47l-14.49 6.11a.45.45 0 01-.2.04zm-.66-14.07c.19 2.27.74 8.82 1.1 12.84l13.55-5.71a11.32 11.32 0 00-.1-1.25z"
          style={{
            WebkitTransformOrigin: 140.122,
            MsTransformOrigin: 140.122,
            transformOrigin: 140.122,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M151.5 107.18s2.79 15.36 2.79 18.16-2.56 10.94-3.72 12.8-7 3-9.31 2.09-8.85-7-10.25-9.54a19.54 19.54 0 01-1.86-4.89s-3.26 1.4-5.82-2.33-1.16-7.21 1.4-7.44l2.33.69s-4.19-7.21-2.8-10.47 18.16-4.42 21.65-4.42 5.59 5.35 5.59 5.35z"
          style={{
            WebkitTransformOrigin: 138.131,
            MsTransformOrigin: 138.131,
            transformOrigin: 138.131,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M143.42 141.05a6.62 6.62 0 01-2.35-.35c-2.47-1-9-7.11-10.49-9.77a20.36 20.36 0 01-1.79-4.5c-1.13.25-3.76.4-5.87-2.67-1.46-2.13-1.84-4.45-1-6.21a3.39 3.39 0 012.78-2 .4.4 0 01.19 0l1.17.35c-1.13-2.19-3.39-7.15-2.24-9.85 1.75-4.07 21.91-4.72 22.11-4.72 3.79 0 6 5.44 6.05 5.67v.09c.11.63 2.8 15.44 2.8 18.25s-2.64 11.2-3.8 13.06c-.98 1.6-4.72 2.65-7.56 2.65zm-14.27-15.75a.53.53 0 01.24.06.51.51 0 01.25.34 19.17 19.17 0 001.81 4.75c1.32 2.42 7.76 8.43 10 9.32s7.72-.33 8.7-1.9c1.09-1.73 3.65-9.8 3.65-12.53s-2.6-17-2.78-18c-.2-.49-2.15-5-5.1-5-5 0-20 1.41-21.19 4.12-1.06 2.48 1.64 8.08 2.77 10a.5.5 0 010 .56.49.49 0 01-.54.17l-2.23-.67a2.42 2.42 0 00-1.87 1.44c-.68 1.44-.33 3.39.94 5.22 2.28 3.32 5.09 2.2 5.21 2.15a.65.65 0 01.14-.03z"
          style={{
            WebkitTransformOrigin: 138.13,
            MsTransformOrigin: 138.13,
            transformOrigin: 138.13,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M138.77 111l-3.71 1.65a1 1 0 00-.48 1.41l.14.25a1 1 0 001.36.41l3.57-1.9a1 1 0 00.41-1.39 1 1 0 00-1.29-.43z"
          style={{
            WebkitTransformOrigin: 137.323,
            MsTransformOrigin: 137.323,
            transformOrigin: 137.323,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M135.61 115.29a1.52 1.52 0 01-1.33-.78l-.13-.25a1.47 1.47 0 01-.11-1.21 1.49 1.49 0 01.82-.9l3.71-1.64a1.5 1.5 0 011.93.64 1.51 1.51 0 01-.61 2.07l-3.58 1.9a1.45 1.45 0 01-.7.17zm3.57-3.91a.52.52 0 00-.21 0l-3.71 1.65a.49.49 0 00-.28.3.53.53 0 000 .41l.14.25a.52.52 0 00.69.2l3.57-1.89a.49.49 0 00.25-.31.48.48 0 000-.39.52.52 0 00-.45-.22zm-.41-.42z"
          style={{
            WebkitTransformOrigin: 137.325,
            MsTransformOrigin: 137.325,
            transformOrigin: 137.325,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M145.67 110.15v.07a.82.82 0 00.61 1l2.87.65a.82.82 0 001-.8.83.83 0 00-.62-.8l-2.85-.71a.82.82 0 00-1.01.59z"
          style={{
            WebkitTransformOrigin: 147.897,
            MsTransformOrigin: 147.897,
            transformOrigin: 147.897,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M149.31 112.4a1.36 1.36 0 01-.29 0l-2.87-.65a1.3 1.3 0 01-.84-.61 1.26 1.26 0 01-.14-1v-.07a1.31 1.31 0 011.59-.93l2.85.71a1.32 1.32 0 01-.32 2.6zm-3.16-2.12v.07a.32.32 0 000 .25.3.3 0 00.2.15l2.87.64a.32.32 0 00.27-.06.35.35 0 00.12-.25.31.31 0 00-.25-.31l-2.84-.71a.32.32 0 00-.39.22z"
          style={{
            WebkitTransformOrigin: 147.865,
            MsTransformOrigin: 147.865,
            transformOrigin: 147.865,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M153.31 130.46s-.45-5.31-1.51-6.07-9-.15-9-.15-8-2.27-8.19-.45c-.12 1.33.24 8.44.58 11.76 2.24 2.15 4.75 4.18 6 4.68 2.32.93 8.14-.23 9.31-2.09a39.42 39.42 0 002.75-7.65zm-1.82.91c-.91 3-2.88 4.85-3.79 4.4s-1.67-3.34-2.43-3.64-1.36 1.21-2.27 2.58-3.34 1.82-4.4.91-2.28-9.26-2.28-10.32 11.08.61 11.08.61a21.74 21.74 0 013.49-.15c.75.15 1.51 2.58.6 5.61z"
          style={{
            WebkitTransformOrigin: 143.948,
            MsTransformOrigin: 143.948,
            transformOrigin: 143.948,
          }}
          fill="gray"
          className="animable"
        ></path>
        <path
          d="M143.42 141.05a6.62 6.62 0 01-2.35-.35c-1.5-.6-4.27-3-6.18-4.79a.46.46 0 01-.15-.31c-.32-3.16-.7-10.41-.58-11.85a1.07 1.07 0 01.47-.8c1.48-1 7 .42 8.27.79 2-.15 8.08-.54 9.19.25s1.6 5.09 1.72 6.41a.44.44 0 010 .2 39.22 39.22 0 01-2.81 7.8c-1 1.6-4.74 2.65-7.58 2.65zm-7.71-5.73a26.71 26.71 0 005.73 4.45c2.19.88 7.72-.33 8.7-1.9a38.52 38.52 0 002.67-7.41c-.21-2.44-.77-5.28-1.3-5.66s-4.92-.35-8.62-.06a.52.52 0 01-.18 0c-2.62-.74-6.68-1.52-7.51-1-.15 1.34.19 8.2.51 11.58zm4.4 1.27a2.88 2.88 0 01-1.84-.59c-1.29-1.11-2.45-9.79-2.45-10.7a.67.67 0 01.24-.5c.95-.81 7.48 0 11.35.61a18.45 18.45 0 013.57-.14 1.3 1.3 0 01.84.68 7.5 7.5 0 01.15 5.56c-.77 2.59-2.2 4.21-3.28 4.67a1.38 1.38 0 01-1.21 0 4.79 4.79 0 01-1.54-2.18 5.37 5.37 0 00-.86-1.45c-.22 0-.73.87-1 1.39-.19.32-.4.67-.63 1a4.18 4.18 0 01-3.3 1.61zm-3.28-11.07c.1 1.88 1.32 9.06 2.1 9.72a2.14 2.14 0 001.62.32 2.92 2.92 0 002-1.13c.22-.32.41-.65.6-1 .67-1.12 1.31-2.18 2.28-1.8.52.21.86.88 1.38 1.94a5.43 5.43 0 001.08 1.72.48.48 0 00.37 0c.86-.37 2.07-1.88 2.72-4 .84-2.78.15-4.82-.23-5a18.86 18.86 0 00-3.33.16h-.13c-4.42-.72-9.39-1.21-10.46-.93z"
          style={{
            WebkitTransformOrigin: 143.979,
            MsTransformOrigin: 143.979,
            transformOrigin: 143.979,
          }}
          fill="#545454"
          className="animable"
        ></path>
        <path
          d="M145.16 128.76a14.18 14.18 0 01-7.3-2.29.5.5 0 11.57-.82s4.28 2.9 8.7 1.9a.5.5 0 01.6.37.5.5 0 01-.37.6 9.94 9.94 0 01-2.2.24z"
          style={{
            WebkitTransformOrigin: 142.683,
            MsTransformOrigin: 142.683,
            transformOrigin: 142.683,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M144.82 113.32s2.12 9.25 2.27 10-1.51 3.19-3.33 1.82a5.35 5.35 0 01-2.13-2.73"
          style={{
            WebkitTransformOrigin: 144.365,
            MsTransformOrigin: 144.365,
            transformOrigin: 144.365,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M144.88 126.06a2.33 2.33 0 01-1.42-.51 5.75 5.75 0 01-2.31-3 .5.5 0 111-.22 5 5 0 001.94 2.44 1.25 1.25 0 001.49.12 2.22 2.22 0 001-1.44c-.15-.74-2.25-9.91-2.27-10a.5.5 0 011-.22c.08.38 2.12 9.27 2.27 10a2.9 2.9 0 01-1.44 2.45 2.43 2.43 0 01-1.26.38z"
          style={{
            WebkitTransformOrigin: 144.359,
            MsTransformOrigin: 144.359,
            transformOrigin: 144.359,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M140.09 117.82c.24.8.15 1.54-.21 1.65s-.85-.45-1.1-1.25-.15-1.54.21-1.65.85.43 1.1 1.25z"
          style={{
            WebkitTransformOrigin: 139.433,
            MsTransformOrigin: 139.433,
            transformOrigin: 139.433,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M149.06 116.58c.1.83-.13 1.54-.5 1.58s-.76-.59-.86-1.42.13-1.55.51-1.59.79.6.85 1.43z"
          style={{
            WebkitTransformOrigin: 148.38,
            MsTransformOrigin: 148.38,
            transformOrigin: 148.38,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M123.33 97.17s-6 6-3.72 11.18 8.15 14.65 8.15 14.65h1.16l-.23-4s3.72-1.39 3-4.65a14.53 14.53 0 00-2.32-5.36s4 3 8.61 2.33 6.75-6.28 8.38-4.42 4.19 3 9.07.46 8-11.23 2.66-14.72-10.34-.4-13.13.29-4.89-4-11.17-2.09a26.18 26.18 0 00-10.46 6.33z"
          style={{
            WebkitTransformOrigin: 139.988,
            MsTransformOrigin: 139.988,
            transformOrigin: 139.988,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M128.92 123.51h-1.16a.5.5 0 01-.43-.24c-.06-.1-5.86-9.63-8.18-14.72-2.43-5.34 3.51-11.41 3.83-11.73a26.37 26.37 0 0110.69-6.41 9.58 9.58 0 018.28 1.2c1.12.62 2 1.11 2.91.89.51-.13 1.11-.34 1.79-.59 2.87-1 7.2-2.59 11.73.36a6.81 6.81 0 013 6.29 11.65 11.65 0 01-5.71 9.3c-4.24 2.22-7.41 2-9.69-.58-.18-.2-.29-.21-.33-.21-.42 0-1.15.67-1.91 1.4-1.33 1.28-3.15 3-5.69 3.4a12.2 12.2 0 01-7.2-1.35 16.14 16.14 0 011.33 3.77c.58 2.69-1.54 4.42-3 5.09l.21 3.6a.47.47 0 01-.14.37.48.48 0 01-.33.16zm-.88-1h.35l-.2-3.43a.5.5 0 01.32-.5c.14 0 3.31-1.29 2.71-4.08a13.86 13.86 0 00-2.23-5.15.5.5 0 010-.66.49.49 0 01.66 0s3.85 2.89 8.23 2.23c2.23-.34 3.85-1.88 5.15-3.13 1-1 1.8-1.7 2.64-1.68a1.44 1.44 0 011 .55c1.24 1.41 3.46 3 8.47.35a10.74 10.74 0 005.18-8.46 5.79 5.79 0 00-2.57-5.4c-4.11-2.68-8-1.28-10.84-.26a19.6 19.6 0 01-1.89.62c-1.29.32-2.43-.32-3.63-1-1.83-1-3.91-2.18-7.52-1.11a25.82 25.82 0 00-10.25 6.15c-.06 0-5.78 5.87-3.63 10.61 2.16 4.56 7.13 12.84 8.01 14.35zm-4.71-25.34z"
          style={{
            WebkitTransformOrigin: 139.988,
            MsTransformOrigin: 139.988,
            transformOrigin: 139.988,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 192.485,
            MsTransformOrigin: 192.485,
            transformOrigin: 192.485,
          }}
          fill="#263238"
          d="M168.58 103.21L167.71 102.71 207.35 34.1 217.26 34.1 217.26 35.1 207.93 35.1 168.58 103.21z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 238.535,
            MsTransformOrigin: 238.535,
            transformOrigin: 238.535,
          }}
          fill="#263238"
          d="M226.38 34.61H250.69V35.61H226.38z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 238.535,
            MsTransformOrigin: 238.535,
            transformOrigin: 238.535,
          }}
          fill="#263238"
          d="M226.38 40.69H250.69V41.69H226.38z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 238.535,
            MsTransformOrigin: 238.535,
            transformOrigin: 238.535,
          }}
          fill="#263238"
          d="M226.38 46.76H250.69V47.76H226.38z"
          className="animable"
        ></path>
      </g>
      <g
        className="animable"
        style={{
          WebkitTransformOrigin: 127.545,
          MsTransformOrigin: 127.545,
          transformOrigin: 127.545,
        }}
      >
        <path
          d="M182.13 236.66a15.6 15.6 0 1115.6-15.6 15.61 15.61 0 01-15.6 15.6zm0-29.2a13.6 13.6 0 1013.6 13.6 13.61 13.61 0 00-13.6-13.6z"
          style={{
            WebkitTransformOrigin: 182.13,
            MsTransformOrigin: 182.13,
            transformOrigin: 182.13,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 198.19,
            MsTransformOrigin: 198.19,
            transformOrigin: 198.19,
          }}
          fill="#263238"
          d="M196.69 231.28H199.69V257.56H196.69z"
          className="animable"
          transform="rotate(-36.87)"
        ></path>
        <path
          d="M164.77 210.11a18.27 18.27 0 01.82 5.89c-.17 2.95.16 7.2 1 7.86s3.11 2.29 2.45 3.6a4.79 4.79 0 01-2.12 2 31.27 31.27 0 01-2.46 7.36c-1.64 3.11-2.78 5.24-4.74 5.4a7 7 0 01-3.11-.32l-2.15 2.1-16.2-3.43.49-7.2s-4.91-8.35-4.91-16.86 8.67-13.41 13.75-13.74 14.56 1.78 17.18 7.34z"
          style={{
            WebkitTransformOrigin: 151.499,
            MsTransformOrigin: 151.499,
            transformOrigin: 151.499,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M154.62 244.53L137.73 241l.51-7.48c-.65-1.16-4.9-8.92-4.9-17 0-8.87 9.11-13.91 14.22-14.24 4.75-.3 14.82 1.62 17.66 7.65v.06a18.6 18.6 0 01.85 6.07c-.2 3.45.28 7 .79 7.44l.22.17c1.1.86 3.15 2.47 2.37 4a5.24 5.24 0 01-2.13 2.08 30.91 30.91 0 01-2.46 7.26c-1.67 3.18-2.88 5.47-5.14 5.66a8.13 8.13 0 01-3-.25zm-15.83-4.38l15.51 3.29 2.17-2.18.31.14a7 7 0 002.87.29c1.64-.14 2.67-1.95 4.35-5.14a30.77 30.77 0 002.4-7.22v-.26l.24-.11a4.29 4.29 0 001.88-1.73c.42-.83-1.4-2.26-2.09-2.8l-.22-.18c-1.17-.93-1.3-6.07-1.17-8.27a17.72 17.72 0 00-.79-5.68c-2.42-5.08-11.39-7.39-16.68-7.05-4.77.31-13.28 5-13.28 13.24s4.79 16.52 4.84 16.6l.08.14z"
          style={{
            WebkitTransformOrigin: 151.481,
            MsTransformOrigin: 151.481,
            transformOrigin: 151.481,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M169 206a7 7 0 01-1.31 4.58c-1.63 2.46-6.05 3.28-6.05 3.28s-.16 3.6-1.15 5.07a10.08 10.08 0 01-3.27 2.62s-3.27.32-2.29 3.92 1.8 4.09.16 7-11.29 6.87-14.56 4.58-5.73-3.43-7.69-10.31-3.93-16.52 1.64-23.07 18.16-4.91 18.16-4.91-3.27-3.11 1.31-2.94a12.2 12.2 0 017.69 3.43s.49-3.27 2.94-2.45 4.11 7.42 4.42 9.2z"
          style={{
            WebkitTransformOrigin: 149.926,
            MsTransformOrigin: 149.926,
            transformOrigin: 149.926,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M143.31 238.3a5.31 5.31 0 01-3.05-.78l-.84-.58c-2.9-2-5.2-3.56-7-10-2.14-7.49-3.88-16.93 1.74-23.53 4.7-5.53 14-5.43 17.38-5.2a2 2 0 01-.37-1.82c.31-.74 1.24-1.07 2.86-1a12.54 12.54 0 017.4 3 3.41 3.41 0 011.32-1.83 2.31 2.31 0 012-.16c3.13 1 4.74 9.46 4.75 9.54a7.55 7.55 0 01-1.39 4.93c-1.46 2.19-4.85 3.14-6 3.41-.07 1-.34 3.65-1.2 4.94a10.25 10.25 0 01-3.47 2.78l-.17.05a2.66 2.66 0 00-1.68 1 2.76 2.76 0 00-.18 2.34c.2.73.39 1.33.56 1.84.66 2.09 1 3-.44 5.57-1.06 1.91-5.18 4.22-9.19 5.14a14.05 14.05 0 01-3.03.36zm5.93-39.15c-4.06 0-10.78.7-14.36 4.91-5.31 6.24-3.61 15.36-1.54 22.61 1.74 6.09 3.8 7.5 6.65 9.45l.85.58c1 .71 2.89.79 5.3.24 3.64-.84 7.63-3 8.54-4.65 1.19-2.16 1-2.77.36-4.78-.17-.53-.37-1.14-.57-1.88a3.69 3.69 0 01.32-3.18 3.54 3.54 0 012.3-1.37 9.3 9.3 0 003-2.41c.74-1.11 1-3.85 1.06-4.82v-.39l.39-.08s4.23-.81 5.73-3a6.69 6.69 0 001.23-4.23c-.45-2.48-2.1-8.11-4.08-8.77a1.42 1.42 0 00-1.22.07 3.21 3.21 0 00-1.08 2l-.15 1-.7-.73a11.81 11.81 0 00-7.35-3.28c-1.63-.06-1.87.32-1.9.4-.15.35.47 1.22.95 1.68l1.11 1-1.51-.19a28.65 28.65 0 00-3.33-.18z"
          style={{
            WebkitTransformOrigin: 149.95,
            MsTransformOrigin: 149.95,
            transformOrigin: 149.95,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M158.55 224s-2.78-5.23-4.91-3.27 0 12.43 3.6 10.47"
          style={{
            WebkitTransformOrigin: 155.671,
            MsTransformOrigin: 155.671,
            transformOrigin: 155.671,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M156.35 232a2.79 2.79 0 01-2.21-1.38c-1.83-2.55-2.61-8.57-.84-10.21a2 2 0 011.73-.54c2 .34 3.77 3.58 4 3.95l-.88.47c-.47-.88-2-3.22-3.25-3.44a1 1 0 00-.88.3c-1.28 1.17-.69 6.57 1 8.88 1 1.37 1.78.93 2.05.78l.48.88a2.32 2.32 0 01-1.2.31z"
          style={{
            WebkitTransformOrigin: 155.667,
            MsTransformOrigin: 155.667,
            transformOrigin: 155.667,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 163.865,
            MsTransformOrigin: 163.865,
            transformOrigin: 163.865,
          }}
          fill="#263238"
          d="M157.24 221.07H170.49V222.07H157.24z"
          className="animable"
        ></path>
        <path
          d="M169.44 225.89l-.6-.8a3.67 3.67 0 001.38-3.82 3.6 3.6 0 00-2.6-2.68 3.72 3.72 0 00-2.4.17l-.39-.93a4.78 4.78 0 013-.21 4.68 4.68 0 011.57 8.27z"
          style={{
            WebkitTransformOrigin: 168.057,
            MsTransformOrigin: 168.057,
            transformOrigin: 168.057,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M158.16 248.76s0-3.65-4.8-6.39-14.4-6.4-18.75-6-6.85 6.63-6.85 6.63 17.14 1.6 21.25 2.51a57.11 57.11 0 019.15 3.25z"
          style={{
            WebkitTransformOrigin: 142.96,
            MsTransformOrigin: 142.96,
            transformOrigin: 142.96,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M158.66 249.54l-.71-.32a56.28 56.28 0 00-9-3.17c-4-.89-21-2.49-21.19-2.5l-.67-.06.26-.63c.1-.26 2.67-6.45 7.26-6.93s14.1 3.18 19 6 5.06 6.67 5.06 6.83zm-30.15-6.92c3.31.31 16.94 1.64 20.61 2.46a53 53 0 018.41 2.86c-.3-1.16-1.26-3.33-4.42-5.14-4.71-2.69-14.25-6.33-18.44-5.88-3.21.34-5.41 4.17-6.16 5.7z"
          style={{
            WebkitTransformOrigin: 142.88,
            MsTransformOrigin: 142.88,
            transformOrigin: 142.88,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M86.39 272.53s-5.48 6.4-12.8 15.55-13.25 18.51-13.25 18.51-6.86 5.94-7.77 8.45-3.2 9.83-4.12 11.89 3.2-.69 3.89-2.29a23.91 23.91 0 011.37-2.74l5.94-2.74s-1.83 4.57 0 5.25 2.06-2.51 4.11-5 3.89-4.35 4.12-7.32a48 48 0 000-6.17l29.25-19z"
          style={{
            WebkitTransformOrigin: 72.7234,
            MsTransformOrigin: 72.7234,
            transformOrigin: 72.7234,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M48.59 328.16a.75.75 0 01-.63-.29 1.2 1.2 0 010-1.14c.57-1.27 1.68-4.62 2.65-7.56.58-1.75 1.11-3.36 1.46-4.3.91-2.51 7.15-8 7.85-8.61.54-.84 6.31-9.83 13.25-18.5 7.24-9 12.76-15.49 12.81-15.55l.41-.48 11.43 15.33-29.42 19.1a48.28 48.28 0 010 5.95c-.22 2.78-1.74 4.61-3.51 6.73l-.72.86a14.46 14.46 0 00-1.69 2.83c-.73 1.51-1.43 2.94-3 2.35a1.63 1.63 0 01-.91-.88c-.47-1.06-.1-2.76.24-3.9l-4.74 2.19a26.92 26.92 0 00-1.26 2.55 7.65 7.65 0 01-4.08 3.32zm37.77-54.82C85 275 80.09 280.76 74 288.39c-7.21 9-13.16 18.37-13.22 18.47l-.1.11c-1.88 1.62-6.91 6.28-7.62 8.24-.34.94-.87 2.53-1.45 4.27-1 2.92-2.06 6.22-2.65 7.58a7.43 7.43 0 002.94-2.61 25.11 25.11 0 011.4-2.81l.08-.13 7.22-3.33-.47 1.16c-.33.84-1.09 3.22-.63 4.25a.62.62 0 00.35.36c.62.23.92-.19 1.74-1.86a14.86 14.86 0 011.81-3l.72-.87c1.73-2.07 3.09-3.71 3.28-6.16a49.36 49.36 0 000-6.1v-.3l.25-.16 28.8-18.68z"
          style={{
            WebkitTransformOrigin: 72.818,
            MsTransformOrigin: 72.818,
            transformOrigin: 72.818,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M54.12 322.18l-.83-.56 2.81-4.23h.19a14.42 14.42 0 003.51-1.58 9.21 9.21 0 002.51-2.27l.82.58a10.81 10.81 0 01-2.79 2.53 15 15 0 01-3.61 1.65z"
          style={{
            WebkitTransformOrigin: 58.21,
            MsTransformOrigin: 58.21,
            transformOrigin: 58.21,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M185.72 263.57l7.41-15.57a62.27 62.27 0 011.78-6.9c.51-.89 3.58-5.74 4.73-5.87s2.3.38 2.43 1.4a2.9 2.9 0 01-.39 1.79 8.88 8.88 0 012.94 2.43 8.1 8.1 0 011.53 4c.26 1 1.15 1.15.13 3.32s-2.68 2.81-3.58 3.44a27.66 27.66 0 01-3.06 1.66s-.13 14.69-1.92 20.44-3.06 7.66-3.06 7.66-3.07-10.47-4.85-12.52-4.09-5.28-4.09-5.28z"
          style={{
            WebkitTransformOrigin: 196.239,
            MsTransformOrigin: 196.239,
            transformOrigin: 196.239,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M194.48 282.49l-.3-1c-.85-2.88-3.34-10.72-4.75-12.33-1.78-2-4.09-5.24-4.12-5.27l-.17-.24 7.51-15.79a56 56 0 011.83-7c0-.05 3.49-5.94 5.1-6.12s2.83.62 3 1.84a3.31 3.31 0 01-.22 1.64 9.38 9.38 0 012.68 2.33 7.47 7.47 0 011.49 3.52c0 .22.08.43.13.63a2.06 2.06 0 00.25.57c.39.72.63 1.4-.16 3.08a7.21 7.21 0 01-3.16 3.27c-.21.13-.41.25-.58.37a25.25 25.25 0 01-2.85 1.57c0 2.21-.27 14.91-1.94 20.27-1.79 5.74-3.07 7.71-3.13 7.79zm-8.18-19c.57.78 2.41 3.28 3.88 5s3.75 8.73 4.61 11.54a48.29 48.29 0 002.46-6.51c1.74-5.61 1.89-20.14 1.89-20.29v-.31l.29-.14a28.14 28.14 0 003-1.61c.19-.13.4-.27.64-.41a6.35 6.35 0 002.78-2.85c.63-1.35.44-1.69.18-2.17a3.08 3.08 0 01-.34-.81c-.06-.22-.1-.44-.15-.68a6.34 6.34 0 00-1.3-3.1 8.49 8.49 0 00-2.75-2.28l-.53-.24.33-.49a2.38 2.38 0 00.3-1.44c-.09-.73-1-1.07-1.88-1s-3.28 3.77-4.34 5.62a53.4 53.4 0 00-1.73 6.75v.11z"
          style={{
            WebkitTransformOrigin: 196.207,
            MsTransformOrigin: 196.207,
            transformOrigin: 196.207,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M96.45 306.13s-9.75 25.14-11.42 31-5.62 17.75-7.3 32.85a95.93 95.93 0 00.09 18.46 153.42 153.42 0 00-7 16.16c-3.62 9.75-15.92 58.11-15.92 58.11s2.23 3.35 7.25 2.51l5-.84a9.06 9.06 0 003.62-.28c2-.55 6.41-.27 6.69-2.22s-1.12-2.51-2.79-4.46-4.18-8.09-4.18-8.09 13.98-24.43 19-33.33 12-25.61 12.29-28.12S116 348.51 116 348.51h3.07l22 36.82s-.84 14.77 1.67 23.41 8.34 41.26 8.34 41.26l-.56 5.86a18.84 18.84 0 011.12 3.62v3.06s.83 2 6.41 2c2.5 0 10.87-.84 12.26-1.12s12-.56 12.26-1.95.56-2.51-1.11-3.07-13.66-6.13-13.66-6.13v-5a9.18 9.18 0 01-2.79-3.35c-.55-1.67.56-46.54 0-54.34s.28-7.8-1.95-14.77S152 318.93 152 318.93l-4.51-7.77-47.37-9.75z"
          style={{
            WebkitTransformOrigin: 118.837,
            MsTransformOrigin: 118.837,
            transformOrigin: 118.837,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M60.59 465.84a7.32 7.32 0 01-6.07-2.84l-.13-.19.06-.21c.12-.49 12.34-48.5 15.93-58.16a161.54 161.54 0 016.92-16.09 97.81 97.81 0 01-.07-18.42 169.15 169.15 0 016.56-30.33c.28-1 .54-1.83.76-2.6 1.66-5.81 11.33-30.78 11.43-31l.07-.12 3.84-5 .31.06 47.59 9.8 4.69 8.12c.09.49 8.86 48.89 11.06 55.75a27.19 27.19 0 011.73 9.71c0 1.3.08 2.92.24 5.17.29 4 .14 17.53 0 30.57-.12 11.19-.25 22.76 0 23.66a8.8 8.8 0 002.61 3.1l.2.15v4.94c1.84.86 11.83 5.49 13.31 6 2 .68 1.74 2.19 1.48 3.52v.12c-.22 1.08-2.47 1.56-10 2.11-1.22.09-2.28.16-2.61.23-1.48.3-9.88 1.13-12.36 1.13-5.74 0-6.77-2-6.87-2.26v-3.26a17.24 17.24 0 00-1.08-3.44l-.05-.11.56-5.91c-.3-1.66-5.91-32.79-8.33-41.12s-1.79-21.74-1.7-23.42L118.76 349h-2.43c-4 10.47-13.83 36.93-14 38.91-.28 2.55-7.31 19.34-12.35 28.31-4.71 8.37-17.45 30.7-18.83 33.13.46 1.11 2.58 6.06 4 7.72.44.51.86.93 1.23 1.29 1.07 1.06 1.91 1.89 1.67 3.57s-2.73 2-4.93 2.3a13.3 13.3 0 00-2.11.34 9.86 9.86 0 01-3.76.3l-4.94.82a10 10 0 01-1.72.15zm-5.11-3.25a6.76 6.76 0 006.62 2.13l5.09-.85h.09a8.73 8.73 0 003.4-.27 15 15 0 012.28-.36c1.74-.21 3.91-.46 4.05-1.46.17-1.17-.38-1.72-1.38-2.7-.39-.39-.83-.82-1.29-1.36-1.7-2-4.16-8-4.26-8.22l-.1-.22.13-.21c.14-.25 14-24.53 18.94-33.34s12-25.44 12.23-27.93 13.66-38 14.23-39.48l.13-.32h3.69l22.22 37.2v.15c0 .14-.81 14.78 1.65 23.24s8.31 41 8.37 41.3v.11l-.55 5.8a16.38 16.38 0 011.11 3.7v2.93c.22.3 1.43 1.59 5.91 1.59 2.52 0 10.9-.86 12.16-1.11.4-.08 1.38-.15 2.74-.25 2.35-.17 8.58-.63 9.15-1.37v-.06c.29-1.46.33-2-.81-2.37-1.68-.56-13.22-5.92-13.71-6.15l-.29-.14v-5.09a9 9 0 01-2.76-3.43c-.28-.85-.2-9.66 0-24 .14-12.42.3-26.49 0-30.49-.16-2.28-.2-3.9-.24-5.21a26.22 26.22 0 00-1.68-9.44c-2.19-6.84-10.54-52.8-11.08-55.78l-4.36-7.5L100.3 302l-3.41 4.42c-.57 1.45-9.77 25.26-11.38 30.88l-.76 2.61A167.46 167.46 0 0078.23 370a96.91 96.91 0 00.08 18.35v.15l-.07.14a157 157 0 00-6.94 16.1C67.87 414 56.41 459 55.48 462.59z"
          style={{
            WebkitTransformOrigin: 118.838,
            MsTransformOrigin: 118.838,
            transformOrigin: 118.838,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M183.07 264.08s.91-3 4.8-1.6 9.82 12.57 8.45 18.51-5 8-8.22 7.77-7.09-4.11-6.18-4.57 1.15-20.11 1.15-20.11z"
          style={{
            WebkitTransformOrigin: 189.153,
            MsTransformOrigin: 189.153,
            transformOrigin: 189.153,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M188.56 289.28h-.5c-2.94-.21-6.49-3.31-6.75-4.63a.78.78 0 01.28-.82c.5-1.14.88-10.95 1-19.74v-.14a3.52 3.52 0 011.69-1.93 4.67 4.67 0 013.75 0c4.31 1.52 10.19 13 8.78 19.09s-5.08 8.17-8.25 8.17zm-6.25-4.77c.27.83 3.26 3.57 5.82 3.75 2.85.22 6.38-1.63 7.71-7.38s-4.67-16.71-8.14-17.93a3.82 3.82 0 00-2.95-.07 2.5 2.5 0 00-1.18 1.29c-.21 17.17-.88 19.83-1.26 20.34zm-.61-.77z"
          style={{
            WebkitTransformOrigin: 189.154,
            MsTransformOrigin: 189.154,
            transformOrigin: 189.154,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M98.5 261.33s-1.6 0-3.88-.22-5.49 3.65-7.32 5.94-4.11 3.66-2.51 8.45 5.94 11 12.34 11.43a13.88 13.88 0 0010.06-3z"
          style={{
            WebkitTransformOrigin: 95.7193,
            MsTransformOrigin: 95.7193,
            transformOrigin: 95.7193,
          }}
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M98.31 287.47H97.1c-6.27-.45-10.94-6.23-12.78-11.77-1.45-4.33.18-6.16 1.75-7.93.28-.32.57-.65.84-1 2.53-3.16 5.44-6.38 7.76-6.13s3.82.22 3.83.22h.35l8.93 23.27-.25.23a14.08 14.08 0 01-9.22 3.11zm-3.89-25.87c-2.11 0-5.45 4.17-6.72 5.76-.29.36-.59.7-.89 1-1.57 1.77-2.81 3.17-1.55 7s5.27 10.64 11.91 11.07a13.86 13.86 0 009.42-2.62l-8.43-22c-.59 0-1.9-.06-3.59-.23z"
          style={{
            WebkitTransformOrigin: 95.7686,
            MsTransformOrigin: 95.7686,
            transformOrigin: 95.7686,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M127.76 243.05s-3.66-.46-11.43 3.89-24.45 17.82-25.6 20.11 2.06 12.57 6.17 14.4a11 11 0 007.77.45l-8.22 24.23s9.14-.46 24.45 2.29 31.1 10.51 31.1 10.51 1.15-.23 1.38-3.2a15.19 15.19 0 011.82-6.17c.69-1.37 9.37-30.86 9.37-30.86s17.15 7.55 21.72 7.55 6.17-8.23 4.34-14.4-5.71-8-5.71-8a30.64 30.64 0 01-9.6-5.26c-4.35-3.65-17.14-9.83-17.14-9.83s-18.31-7.76-30.42-5.71z"
          style={{
            WebkitTransformOrigin: 140.933,
            MsTransformOrigin: 140.933,
            transformOrigin: 140.933,
          }}
          fill="#4CB967"
          className="animable"
        ></path>
        <path
          d="M151.92 319.45l-.16-.07c-.15-.08-15.88-7.77-30.95-10.47s-24.25-2.28-24.34-2.28h-.73l8.16-24a11.73 11.73 0 01-7.2-.74c-3-1.32-5-6.27-5.49-7.76-.88-2.46-1.65-5.85-.92-7.31 1.22-2.45 18.11-16 25.8-20.33 7.29-4.08 11-4 11.65-3.95 12.11-2 29.86 5.44 30.61 5.75.55.27 12.93 6.25 17.27 9.91a30.43 30.43 0 009.42 5.16c.24.1 4.18 2 6.05 8.34 1.38 4.65.83 10.28-1.27 13.1a4.39 4.39 0 01-3.55 1.94c-4.23 0-18.43-6.07-21.4-7.36-1.22 4.15-8.59 29.09-9.24 30.39a14.9 14.9 0 00-1.78 6c-.24 3.19-1.51 3.6-1.77 3.65zM98 305.61a134.46 134.46 0 0123 2.31c14.22 2.55 29 9.5 31 10.45.22-.18.73-.79.88-2.68a15.45 15.45 0 011.88-6.35c.54-1.1 6.92-22.59 9.34-30.78l.16-.54.52.23c.17.07 17.09 7.5 21.51 7.5a3.38 3.38 0 002.75-1.54c1.93-2.59 2.41-7.84 1.11-12.22-1.74-5.89-5.41-7.67-5.45-7.69a30.7 30.7 0 01-9.7-5.3c-4.24-3.58-16.9-9.7-17-9.77s-18.26-7.68-30.1-5.67h-.14c-.07 0-3.68-.33-11.13 3.82-7.9 4.42-24.35 17.82-25.39 19.9-.39.78-.18 3.33 1 6.54 1.32 3.65 3.21 6.41 5 7.18a10.6 10.6 0 007.39.45l1-.37-8.34 24.54z"
          style={{
            WebkitTransformOrigin: 140.924,
            MsTransformOrigin: 140.924,
            transformOrigin: 140.924,
          }}
          fill="#263238"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 161.315,
            MsTransformOrigin: 161.315,
            transformOrigin: 161.315,
          }}
          fill="#263238"
          d="M166.88 279.77L155.75 277.13 155.99 276.16 162.23 277.64 157.63 274.31 158.22 273.5 166.88 279.77z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 112.99,
            MsTransformOrigin: 112.99,
            transformOrigin: 112.99,
          }}
          fill="#263238"
          d="M111.04 255.38H114.94000000000001V256.38H111.04z"
          className="animable"
          transform="rotate(-72.26)"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 107.965,
            MsTransformOrigin: 107.965,
            transformOrigin: 107.965,
          }}
          fill="#263238"
          d="M97.16 271.11H118.77V272.11H97.16z"
          className="animable"
          transform="rotate(-72.26)"
        ></path>
      </g>
      <defs>
        <filter id="active" height="200%">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius="2"
            result="DILATED"
          ></feMorphology>
          <feFlood
            floodColor="#32DFEC"
            floodOpacity="1"
            result="PINK"
          ></feFlood>
          <feComposite
            in="PINK"
            in2="DILATED"
            operator="in"
            result="OUTLINE"
          ></feComposite>
          <feMerge>
            <feMergeNode in="OUTLINE"></feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
        </filter>
        <filter id="hover" height="200%">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius="2"
            result="DILATED"
          ></feMorphology>
          <feFlood floodColor="red" floodOpacity="0.5" result="PINK"></feFlood>
          <feComposite
            in="PINK"
            in2="DILATED"
            operator="in"
            result="OUTLINE"
          ></feComposite>
          <feMerge>
            <feMergeNode in="OUTLINE"></feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
          <feColorMatrix values="0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"></feColorMatrix>
        </filter>
      </defs>
    </svg>
  );
}
